import { useState, useEffect } from 'react'
import { FiX, FiArrowLeft } from 'react-icons/fi'
import api from '../utils/api'

const fmt = (v) => (v == null || isNaN(v)) ? '' : Number(v).toLocaleString('tr-TR', { minimumFractionDigits: 0, maximumFractionDigits: 0 })
const fmtDvz = (obj) => {
  if (!obj) return '-'
  const order = { '₺': 0, 'TL': 0, '€': 1, 'EUR': 1, '$': 2 }
  const parts = Object.entries(obj).filter(([, v]) => Math.abs(v) >= 0.5)
    .sort(([a], [b]) => (order[a] ?? 9) - (order[b] ?? 9))
    .map(([d, v]) => `${fmt(v)} ${d}`)
  return parts.length ? parts.join('  +  ') : '0'
}
// Döviz bazlı değerleri ALT ALTA göster (dar hücrelerde taşmasın) — her para birimi kendi satırında
const fmtDvzList = (obj) => {
  const order = { '₺': 0, 'TL': 0, '€': 1, 'EUR': 1, '$': 2 }
  const parts = Object.entries(obj || {}).filter(([, v]) => Math.abs(v) >= 0.5)
    .sort(([a], [b]) => (order[a] ?? 9) - (order[b] ?? 9))
  return parts.map(([d, v]) => <div key={d} className="tabular-nums leading-tight whitespace-nowrap">{fmt(v)} {d}</div>)
}

// qr22: kullanicinin sectigi para modu — panolar ve Anlık Rapor ile AYNI anahtar.
// "₺ TL" secilmisse detay pencerelerinde de doviz kirilimi yerine TL karsiligi gosterilir.
const paraTL = () => {
  try {
    const u = JSON.parse(localStorage.getItem('user') || '{}')
    return (localStorage.getItem(`currencyMode_user_${u?.id || 'anon'}`)
         || localStorage.getItem('currencyMode') || '') === 'tl'
  } catch { return false }
}
// TL modunda ve TL karsiligi varsa "1.234 ₺", degilse doviz kirilimi
const fmtPara = (dvz, tl) => (paraTL() && tl != null ? `${fmt(tl)} ₺` : fmtDvz(dvz))
const fmtParaList = (dvz, tl) => (paraTL() && tl != null
  ? <div className="tabular-nums leading-tight whitespace-nowrap">{fmt(tl)} ₺</div>
  : fmtDvzList(dvz))

const AY_ADI = { 1: 'Ocak', 2: 'Şubat', 3: 'Mart', 4: 'Nisan', 5: 'Mayıs', 6: 'Haziran', 7: 'Temmuz', 8: 'Ağustos', 9: 'Eylül', 10: 'Ekim', 11: 'Kasım', 12: 'Aralık' }
// "2025-01" -> "2025 Ocak"
const ayEtiket = (v) => {
  const m = String(v || '').match(/^(\d{4})-(\d{2})$/)
  return m ? `${m[1]} ${AY_ADI[parseInt(m[2])] || m[2]}` : String(v || '')
}

// type: 'cari' | 'sefer' | 'arac' | 'grup' | 'ay'  ; value: unvan / sefer id / plaka / grup adı / YYYY-MM
// extra: grup için { ds_id, period }
export default function LojDetayModal({ type, value, extra, onClose }) {
  // Navigasyon yığını: araç → sefer no'ya tıkla → sefer detayı → geri ile araca dön
  const [stack, setStack] = useState([{ type, value, extra }])
  const cur = stack[stack.length - 1]
  const navigate = (d) => setStack(s => [...s, d])
  const goBack = () => setStack(s => s.length > 1 ? s.slice(0, -1) : s)

  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(true)
  const [err, setErr] = useState(null)
  // Tarih filtresi: cari / petrol-cari / araç için. (sefer tek kayıt, grup period bazlı → yok)
  const showDate = cur.type === 'cari' || cur.type === 'petrol-cari' || cur.type === 'petrol-satis' || cur.type === 'petrol-alis' || cur.type === 'arac'
  const [dateMode, setDateMode] = useState((cur.type === 'arac' && !cur.extra?.tum) ? 'ay' : 'tum')
  const [seferAcik, setSeferAcik] = useState({})  // sefer listesi ay/yıl açık durumu — navigasyonda korunur
  const [cbas, setCbas] = useState('')
  const [cbit, setCbit] = useState('')

  // Detay değişince (ileri/geri) tarih filtresini sıfırla — sayfa filtresi (extra.bas/bit) varsa onunla başla
  useEffect(() => {
    const eb = cur.extra?.bas, et = cur.extra?.bit
    if (eb || et) { setDateMode('ozel'); setCbas(eb || ''); setCbit(et || '') }
    else { setDateMode((cur.type === 'arac' && !cur.extra?.tum) ? 'ay' : 'tum'); setCbas(''); setCbit('') }
  }, [stack.length])

  // ESC ile kapat (tablo/kolon genişletmesi başlığı kaçırsa bile her zaman kapatılabilsin)
  useEffect(() => {
    const h = (e) => { if (e.key === 'Escape') onClose && onClose() }
    window.addEventListener('keydown', h)
    return () => window.removeEventListener('keydown', h)
  }, [onClose])

  const _isoToday = () => {
    const d = new Date()
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`
  }
  const _range = () => {
    const now = new Date(); const y = now.getFullYear(); const m = now.getMonth()
    const iso = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`
    if (dateMode === 'ozel') return [cbas, cbit]
    if (dateMode === 'ay') return [iso(new Date(y, m, 1)), iso(now)]
    if (dateMode === 'yil') return [iso(new Date(y, 0, 1)), iso(now)]
    return ['', '']  // tüm
  }

  useEffect(() => {
    const { type: t, value: v, extra: ex } = cur
    if (!t || v == null) return
    const [bs, bt] = _range()
    // Tek taraf dolu ise de gonder: bas yok -> ilk islemden itibaren, bit yok -> bugune kadar
    const dq = (bs ? `&bas=${bs}` : '') + (bt ? `&bit=${bt}` : '')
    const dqP = (bs ? `&tarih_bas=${bs}` : '') + (bt ? `&tarih_bit=${bt}` : '')
    setLoading(true); setErr(null); setData(null)
    const url = t === 'cari' ? `/anlik-rapor/loj-cari?unvan=${encodeURIComponent(v)}${dq}`
      : t === 'petrol-cari' ? `/cari-detay/_?tum=true&unvan_q=${encodeURIComponent(v)}${dqP}`
      : t === 'petrol-satis' ? `/musteri-satis/_?unvan_q=${encodeURIComponent(v)}${dqP}`
      : t === 'petrol-alis' ? `/petrol-son-alis/_?urun_q=${encodeURIComponent(v)}${dqP}`
      : t === 'fatura' ? `/anlik-rapor/loj-fatura?id=${encodeURIComponent(v)}`
      : t === 'sefer' ? `/anlik-rapor/loj-sefer?id=${encodeURIComponent(v)}`
      : t === 'sefer_detay' ? `/anlik-rapor/loj-sefer-detay?id=${encodeURIComponent(v)}`
      : t === 'cari-seferler' ? `/anlik-rapor/loj-cari-seferler?cari_id=${encodeURIComponent(v)}`
      : t === 'grup' ? `/anlik-rapor/market-grup?ds_id=${ex?.ds_id}&grup=${encodeURIComponent(v)}&period=${ex?.period || 'daily'}`
      : t === 'ay' ? `/anlik-rapor/loj-ay?ay=${encodeURIComponent(v)}&tip=${ex?.tip || 1}`
      : t === 'sofor' ? `/anlik-rapor/loj-sofor?sofor=${encodeURIComponent(v)}`
      : t === 'vade' ? `/anlik-rapor/loj-vade?cari=${encodeURIComponent(v)}`
      : t === 'seferliste' ? `/anlik-rapor/loj-sefer-liste?mod=${ex?.mod || 'gun'}&deger=${encodeURIComponent(v)}&tasima_turu=${ex?.tt || 'YI'}&arac_tipi=${ex?.at || ''}&arac_turu=${ex?.tr || ''}${ex?.bas ? `&bas=${ex.bas}` : ''}${ex?.bit ? `&bit=${ex.bit}` : ''}`
      : t === 'cariliste' ? `/anlik-rapor/loj-cari-bakiye-liste?tip=${encodeURIComponent(v || 'tum')}&tasima_turu=${ex?.tt || 'YI'}${ex?.bas ? `&bas=${ex.bas}` : ''}${ex?.bit ? `&bit=${ex.bit}` : ''}`
      : t === 'aracliste' ? `/anlik-rapor/loj-arac-liste?tasima_turu=${ex?.tt || 'YI'}&arac_turu=${ex?.tr || '1'}&arac_tipi=${ex?.at || ''}`
      : t === 'giderdetay' ? `/anlik-rapor/loj-gider-detay?tasima_turu=${ex?.tt || 'YD'}${ex?.bas ? `&bas=${ex.bas}` : ''}${ex?.bit ? `&bit=${ex.bit}` : ''}`
      : `/anlik-rapor/loj-arac?plaka=${encodeURIComponent(v)}${dateMode === 'tum' ? '&tum=true' : dq}`
    api.get(url)
      .then(({ data }) => setData(data))
      .catch((e) => setErr(e?.response?.data?.detail || 'Veri alınamadı'))
      .finally(() => setLoading(false))
  }, [stack.length, dateMode, cbas, cbit])

  const baslik = cur.type === 'cari' ? `Cari Detay (Lojistik) — ${cur.value}`
    : cur.type === 'petrol-cari' ? `Petrol Cari Detay (3 İstasyon) — ${cur.value}`
    : cur.type === 'petrol-satis' ? `Müşteri Satış Detayı (3 İstasyon) — ${cur.value}`
    : cur.type === 'petrol-alis' ? `Son Alışlar (3 İstasyon) — ${cur.value}`
    : cur.type === 'fatura' ? `Fatura Detay${data?.kunye?.fatura_no ? ` — ${data.kunye.fatura_no}` : ''}`
    : cur.type === 'sefer' ? `Sefer Detay — #${cur.value}`
    : cur.type === 'cari-seferler' ? `Müşteri Seferleri${data?.unvan ? ` — ${data.unvan}` : ''}`
    : cur.type === 'sefer_detay' ? `Taşıma Detayı — Sefer Detay #${cur.value}`
    : cur.type === 'grup' ? `Grup Ürünleri — ${cur.value}`
    : cur.type === 'sofor' ? `Şoför Detay — ${cur.value}`
    : cur.type === 'vade' ? `Vade / Açık Evrak Detayı — ${cur.value}`
    : cur.type === 'ay' ? `Aylık İşlemler — ${ayEtiket(cur.value)} (${cur.extra?.tip === 2 ? 'Yurt Dışı' : 'Yurt İçi'})`
    : cur.type === 'seferliste' ? (data?.baslik || 'Sefer Listesi')
    : cur.type === 'cariliste' ? (data?.baslik || 'Cari Listesi')
    : cur.type === 'aracliste' ? (data?.baslik || 'Araç Listesi')
    : cur.type === 'giderdetay' ? (data?.baslik || 'Gider Dökümü')
    : `Araç Detay — ${cur.value}`

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/50 p-4"
      onClick={(e) => { if (e.target === e.currentTarget) onClose && onClose() }}>
      {/* max-h Tailwind arbitrary degeri derlenmiyor -> inline style (yoksa modal icerikle
          birlikte uzuyor, baslik viewport disina kaciyor ve kapatilamiyordu) */}
      <div className="bg-white dark:bg-gray-800 rounded-xl shadow-2xl w-full max-w-5xl flex flex-col overflow-hidden"
        style={{ maxHeight: '88vh' }}>
        <div className="bg-slate-700 dark:bg-slate-900 text-white px-4 py-2.5 flex items-center gap-2 flex-shrink-0">
          {stack.length > 1 && (
            <button onClick={goBack} title="Geri" className="text-white/80 hover:text-white p-1 -ml-1 flex items-center gap-1">
              <FiArrowLeft size={16} /><span className="text-xs">Geri</span>
            </button>
          )}
          <span className="text-sm font-semibold truncate">{baslik}</span>
          <button onClick={onClose} className="ml-auto text-white/70 hover:text-white p-1"><FiX size={18} /></button>
        </div>
        {showDate && (
          <div className="flex flex-wrap items-center gap-1.5 px-3 py-2 bg-slate-100 dark:bg-gray-700/40 border-b border-slate-200 dark:border-gray-700 text-[11px] flex-shrink-0">
            {[['ay', 'Bu Ay'], ['yil', 'Bu Yıl'], ['tum', 'Tümü']].map(([k, l]) => (
              <button key={k} onClick={() => setDateMode(k)}
                className={`px-2.5 py-1 rounded font-medium ${dateMode === k ? 'bg-slate-700 text-white' : 'bg-white dark:bg-gray-800 text-gray-600 dark:text-gray-300 border border-slate-200 dark:border-gray-600'}`}>
                {l}
              </button>
            ))}
            <span className="text-gray-400 mx-1">|</span>
            <span className="text-gray-500">Tarih:</span>
            <input type="date" value={cbas} max={_isoToday()}
              onChange={e => { setCbas(e.target.value); setDateMode('ozel') }}
              className="border border-slate-300 dark:border-gray-600 rounded px-1.5 py-0.5 bg-white dark:bg-gray-800" />
            <span className="text-gray-400">–</span>
            <input type="date" value={cbit} max={_isoToday()}
              onChange={e => { setCbit(e.target.value); setDateMode('ozel') }}
              className="border border-slate-300 dark:border-gray-600 rounded px-1.5 py-0.5 bg-white dark:bg-gray-800" />
            {dateMode === 'ozel' && (cbas || cbit) && (
              <button onClick={() => { setCbas(''); setCbit(''); setDateMode((cur.type === 'arac' && !cur.extra?.tum) ? 'ay' : 'tum') }}
                className="text-gray-400 hover:text-gray-600 ml-1">temizle</button>
            )}
          </div>
        )}
        <div className="overflow-auto px-3 pb-3 pt-0 text-[12px] [&>div]:pt-3" style={{ minHeight: 0 }}>
          {loading ? <div className="p-8 text-center text-gray-400">Yükleniyor...</div>
            : err ? <div className="p-8 text-center text-red-500">{err}</div>
              : cur.type === 'cari' ? <CariView d={data} extra={cur.extra} onNavigate={navigate} />
                : cur.type === 'petrol-cari' ? <PetrolCariView d={data} />
                : cur.type === 'petrol-satis' ? <PetrolSatisView d={data} />
                : cur.type === 'petrol-alis' ? <PetrolAlisView d={data} />
                : cur.type === 'fatura' ? <FaturaView d={data} onNavigate={navigate} />
                  : cur.type === 'sefer' ? <SeferView d={data} onNavigate={navigate} />
                    : cur.type === 'cari-seferler' ? <CariSeferlerView d={data} onNavigate={navigate} />
                    : cur.type === 'sefer_detay' ? <SeferDetayView d={data} onNavigate={navigate} />
                    : cur.type === 'grup' ? <GrupView d={data} />
                    : cur.type === 'ay' ? <AyView d={data} onNavigate={navigate} />
                    : cur.type === 'sofor' ? <SoforView d={data} onNavigate={navigate} />
                    : cur.type === 'vade' ? <VadeView d={data} />
                    : cur.type === 'seferliste' ? <SeferListeView d={data} onNavigate={navigate} acik={seferAcik} setAcik={setSeferAcik} />
                    : cur.type === 'cariliste' ? <CariBakiyeListeView d={data} onNavigate={navigate} />
                    : cur.type === 'aracliste' ? <AracListeView d={data} onNavigate={navigate} />
                    : cur.type === 'giderdetay' ? <GiderDetayView d={data} />
                      : <AracView d={data} onNavigate={navigate} />}
        </div>
      </div>
    </div>
  )
}

// Başlık: tek satır + sağ kenardan tutup genişliği ayarlanabilir (resize-x)
function Th({ children, r }) { return <th className={`px-2 py-1 font-medium bg-gray-100 dark:bg-gray-700 sticky top-0 z-20 shadow-[0_1px_0_rgba(0,0,0,0.1)] whitespace-nowrap resize-x overflow-hidden min-w-[55px] ${r ? 'text-right' : 'text-left'}`}>{children}</th> }
// Hücreler tek satır (tarih bölünmesin); açıklama gibi uzunlar cls="truncate max-w-..." ile kesilir
function Td({ children, r, cls = '' }) { return <td className={`px-2 py-1 whitespace-nowrap ${r ? 'text-right tabular-nums' : ''} ${cls}`}>{children}</td> }

function CariView({ d, extra, onNavigate }) {
  if (!d) return null
  return (
    <div>
      {extra?.seferler_cari && onNavigate && (
        <div className="flex gap-1 mb-3">
          <span className="px-3 py-1 rounded-lg text-xs font-medium bg-slate-700 text-white">Bakiye</span>
          <button onClick={() => onNavigate({ type: 'cari-seferler', value: String(extra.seferler_cari) })}
            className="px-3 py-1 rounded-lg text-xs font-medium bg-white dark:bg-gray-800 text-gray-600 dark:text-gray-300 border border-slate-200 dark:border-gray-600 hover:bg-slate-100 dark:hover:bg-gray-700">
            🚚 Seferler
          </button>
        </div>
      )}
      <div className="flex flex-wrap gap-2 mb-3">
        {Object.entries(d.devir_dvz || {}).map(([dov, v]) => (
          <div key={'dv-' + dov} className="px-3 py-1.5 rounded-lg border border-dashed dark:border-gray-600 bg-amber-50 dark:bg-amber-900/20">
            <div className="text-[10px] text-gray-500">Devir Bakiye ({dov})</div>
            <div className={`text-base font-bold tabular-nums ${v > 0 ? 'text-red-600' : 'text-green-600'}`}>{fmt(v)} {dov}</div>
          </div>
        ))}
        {Object.entries(d.toplam_borc_dvz || {}).map(([dov, v]) => (
          <div key={'tb-' + dov} className="px-3 py-1.5 rounded-lg border dark:border-gray-600 bg-red-50 dark:bg-red-900/15">
            <div className="text-[10px] text-gray-500">Toplam Borç ({dov})</div>
            <div className="text-base font-bold tabular-nums text-red-600">{fmt(v)} {dov}</div>
          </div>
        ))}
        {Object.entries(d.toplam_alacak_dvz || {}).map(([dov, v]) => (
          <div key={'ta-' + dov} className="px-3 py-1.5 rounded-lg border dark:border-gray-600 bg-green-50 dark:bg-green-900/15">
            <div className="text-[10px] text-gray-500">Toplam Alacak ({dov})</div>
            <div className="text-base font-bold tabular-nums text-green-600">{fmt(v)} {dov}</div>
          </div>
        ))}
        {Object.entries(d.bakiye_dvz || {}).map(([dov, v]) => (
          <div key={dov} className="px-3 py-1.5 rounded-lg border dark:border-gray-600 bg-slate-50 dark:bg-gray-700/40">
            <div className="text-[10px] text-gray-500">Bakiye ({dov})</div>
            <div className={`text-base font-bold tabular-nums ${v > 0 ? 'text-red-600' : 'text-green-600'}`}>{fmt(v)} {dov}</div>
          </div>
        ))}
        {(!d.bakiye_dvz || Object.keys(d.bakiye_dvz).length === 0) && !(d.seferler?.length) && <div className="text-gray-400 py-2">Hareket yok</div>}
      </div>
      <CariHareketAgaci d={d} onNavigate={onNavigate} />
      {(d.seferler?.length > 0) && (
        <div className="mt-4">
          <div className="text-xs font-semibold text-gray-500 mb-1">🚚 Seferler ({d.sefer_sayisi ?? d.seferler.length})</div>
          <table className="w-full">
            <thead><tr><Th>Sefer No</Th><Th>Tarih</Th><Th>Tip</Th><Th>Durum</Th><Th>Plaka</Th><Th>Güzergah</Th><Th r>Gelir</Th><Th r>Gider</Th><Th r>Kar</Th></tr></thead>
            <tbody>
              {d.seferler.map((s, i) => (
                <tr key={i} className="border-b border-gray-50 dark:border-gray-700 hover:bg-blue-50/30 dark:hover:bg-blue-900/20">
                  <Td><span onClick={() => onNavigate && onNavigate({ type: 'sefer', value: s.sefer_no })}
                        className="text-blue-600 dark:text-blue-400 cursor-pointer hover:underline font-medium">#{s.sefer_no}</span></Td>
                  <Td>{s.tarih}</Td>
                  <Td cls="text-gray-500">{s.tip}</Td>
                  <Td>{s.durum}</Td>
                  <Td><span onClick={() => (s.plaka && s.plaka !== '-' && onNavigate) ? onNavigate({ type: 'arac', value: s.plaka }) : null}
                        className={s.plaka && s.plaka !== '-' ? 'text-blue-600 dark:text-blue-400 cursor-pointer hover:underline' : ''}>{s.plaka}</span></Td>
                  <Td cls="text-gray-500 truncate max-w-[260px]">{s.guzergah}</Td>
                  <Td r cls="text-green-600">{s.gelir > 0 ? `${fmt(s.gelir)} ${s.doviz}` : ''}</Td>
                  <Td r cls="text-red-600">{s.gider > 0 ? `${fmt(s.gider)} ${s.doviz}` : ''}</Td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  )
}

// Cari hareketleri YIL -> AY gruplu agac + islem turu ve sefer no kolonlari
const MODUL_AD = { fatura: 'Fatura', kasa_hareket: 'Kasa/Tahsilat', arac_gelir_gider: 'Araç G/G',
                   'sefer-Hakedis': 'Hakediş', 'sefer-Avans': 'Avans', diger: 'Diğer' }
const CARI_AY_AD = ['', 'Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran', 'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık']

function CariHareketAgaci({ d, onNavigate }) {
  const [acik, setAcik] = useState({})
  const hareketler = [...(d.hareketler || [])].sort((a, b) => String(b.tarih || '').localeCompare(String(a.tarih || '')))
  if (hareketler.length === 0) return null
  // yil -> ay -> satirlar
  const grup = {}
  hareketler.forEach(h => {
    const t = String(h.tarih || ''); const y = t.slice(0, 4) || '?'; const a = t.slice(0, 7) || '?'
    if (!grup[y]) grup[y] = {}
    if (!grup[y][a]) grup[y][a] = []
    grup[y][a].push(h)
  })
  const yillar = Object.keys(grup).sort().reverse()
  const enYeniYil = yillar[0]
  const enYeniAy = Object.keys(grup[enYeniYil] || {}).sort().reverse()[0]
  const acikMi = (k, defAcik) => (acik[k] === undefined ? defAcik : acik[k])
  const tgl = (k, defAcik) => setAcik(p => ({ ...p, [k]: !acikMi(k, defAcik) }))
  // doviz bazli toplam metni: "1.234 ₺ · 56 €"
  const topla = (rows, alan) => {
    const o = {}
    rows.forEach(h => { const v = Number(h[alan]) || 0; if (v > 0.004) o[h.doviz] = (o[h.doviz] || 0) + v })
    return Object.entries(o).map(([dv, v]) => `${fmt(v)} ${dv}`).join(' · ')
  }
  const IslemHucre = ({ h }) => {
    let ad = MODUL_AD[h.modul] || h.modul || '-'
    if (h.modul === 'fatura') ad = h.fatura_tipi === 1 ? 'Gelen Fatura' : h.fatura_tipi === 2 ? 'Giden Fatura' : 'Fatura'
    return (
      <span className="whitespace-nowrap">
        {ad}
        {h.fatura_id != null && (
          <button onClick={(e) => { e.stopPropagation(); onNavigate && onNavigate({ type: 'fatura', value: String(h.fatura_id) }) }}
            title="Fatura detayını aç"
            className="ml-1 text-blue-600 dark:text-blue-400 hover:underline font-medium">{h.fatura_no || `#${h.fatura_id}`}</button>
        )}
        {h.sefer_id != null && (
          <button onClick={(e) => { e.stopPropagation(); onNavigate && onNavigate({ type: 'sefer', value: String(h.sefer_id) }) }}
            className="ml-1 text-indigo-600 dark:text-indigo-400 hover:underline font-medium">Sefer #{h.sefer_id}</button>
        )}
      </span>
    )
  }
  return (
    <table className="w-full">
      <thead><tr><Th>Tarih</Th><Th>İşlem</Th><Th r>Borç</Th><Th r>Alacak</Th><Th r>Dönem Bakiye</Th><Th r>Genel Bakiye</Th><Th>Açıklama</Th></tr></thead>
      <tbody>
        {yillar.flatMap(y => {
          const yk = `y${y}`; const yAcik = acikMi(yk, y === enYeniYil)
          const yRows = Object.values(grup[y]).flat()
          const out = [(
            <tr key={yk} onClick={() => tgl(yk, y === enYeniYil)}
              className="bg-slate-200 dark:bg-slate-700 cursor-pointer hover:bg-slate-300 dark:hover:bg-slate-600 select-none">
              <Td cls="font-bold whitespace-nowrap">{yAcik ? '▾' : '▸'} {y} ({yRows.length})</Td>
              <Td />
              <Td r cls="text-red-600 font-bold">{topla(yRows, 'borc')}</Td>
              <Td r cls="text-green-600 font-bold">{topla(yRows, 'alacak')}</Td>
              <Td /><Td /><Td />
            </tr>
          )]
          if (!yAcik) return out
          Object.keys(grup[y]).sort().reverse().forEach(a => {
            const ak = `a${a}`; const aAcik = acikMi(ak, a === enYeniAy)
            const rows = grup[y][a]
            const ayNo = parseInt(a.split('-')[1]) || 0
            out.push(
              <tr key={ak} onClick={() => tgl(ak, a === enYeniAy)}
                className="bg-gray-50 dark:bg-gray-700/50 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700 select-none">
                <Td cls="pl-4 font-semibold text-gray-600 dark:text-gray-300 whitespace-nowrap">{aAcik ? '▾' : '▸'} {CARI_AY_AD[ayNo] || a} ({rows.length})</Td>
                <Td />
                <Td r cls="text-red-500 font-medium">{topla(rows, 'borc')}</Td>
                <Td r cls="text-green-500 font-medium">{topla(rows, 'alacak')}</Td>
                <Td /><Td /><Td />
              </tr>
            )
            if (aAcik) rows.forEach((h, i) => out.push(
              <tr key={`${ak}-${i}`} className="border-b border-gray-50 dark:border-gray-700 hover:bg-blue-50/30 dark:hover:bg-blue-900/20">
                <Td cls="pl-7 whitespace-nowrap">{h.tarih}</Td>
                <Td><IslemHucre h={h} /></Td>
                <Td r cls="text-red-600">{h.borc > 0 ? `${fmt(h.borc)} ${h.doviz}` : ''}</Td>
                <Td r cls="text-green-600">{h.alacak > 0 ? `${fmt(h.alacak)} ${h.doviz}` : ''}</Td>
                <Td r cls={h.donem_bakiye > 0 ? 'text-red-600' : 'text-green-600'}>{fmt(h.donem_bakiye)} {h.doviz}</Td>
                <Td r cls={h.bakiye > 0 ? 'text-red-700 font-semibold' : 'text-green-700 font-semibold'}>{fmt(h.bakiye)} {h.doviz}</Td>
                <Td cls="text-gray-500 truncate max-w-[260px]" title={h.aciklama}>{h.aciklama}</Td>
              </tr>
            ))
          })
          return out
        })}
      </tbody>
    </table>
  )
}

function FaturaView({ d, onNavigate }) {
  if (!d) return null
  const k = d.kunye || {}
  const satir = (l, v, onClick) => (
    <div className="flex gap-2 py-0.5"><span className="text-gray-500 w-32 flex-shrink-0">{l}</span>
      <span className={`font-medium ${onClick ? 'text-blue-600 dark:text-blue-400 cursor-pointer hover:underline' : ''}`} onClick={onClick}>{v}</span></div>
  )
  return (
    <div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 mb-3 p-3 rounded-lg bg-slate-50 dark:bg-gray-700/40">
        {satir('Fatura No', k.fatura_no)}
        {satir('e-Fatura No', k.efatura_no)}
        {satir('Tip', k.tip)}
        {satir('Cari', k.cari)}
        {satir('Tarih', k.tarih)}
        {satir('Vade', k.vade)}
        {satir('Ara Tutar', `${fmt(k.ara_tutar)} ${k.doviz}`)}
        {satir('KDV', `${fmt(k.kdv)} ${k.doviz}`)}
        {satir('Toplam', `${fmt(k.toplam)} ${k.doviz}`)}
        {satir('Kaydeden', k.kaydeden)}
        {(k.seferler || []).length > 0 && (
          <div className="flex gap-2 py-0.5"><span className="text-gray-500 w-32 flex-shrink-0">Sefer{k.seferler.length > 1 ? 'ler' : ''}</span>
            <span className="font-medium flex flex-wrap gap-x-2">
              {k.seferler.map(sid => (
                <button key={sid} onClick={() => onNavigate && onNavigate({ type: 'sefer', value: String(sid) })}
                  className="text-blue-600 dark:text-blue-400 hover:underline">#{sid}</button>
              ))}
            </span></div>
        )}
        {k.aciklama && k.aciklama !== '-' && satir('Açıklama', k.aciklama)}
      </div>
      <div className="text-[11px] font-semibold text-gray-600 dark:text-gray-300 mb-1">Fatura Kalemleri ({(d.kalemler || []).length})</div>
      <table className="w-full">
        <thead><tr><Th>Kalem</Th><Th>Açıklama</Th><Th r>Miktar</Th><Th r>Br.Fiyat</Th><Th r>KDV %</Th><Th r>Tutar</Th></tr></thead>
        <tbody>
          {(d.kalemler || []).map((h, i) => (
            <tr key={i} className="border-b border-gray-50 dark:border-gray-700 hover:bg-blue-50/30 dark:hover:bg-blue-900/20">
              <Td>{h.kalem}</Td>
              <Td cls="text-gray-500 truncate max-w-[240px]" title={h.aciklama}>{h.aciklama}</Td>
              <Td r>{fmt(h.miktar)} {h.birim}</Td>
              <Td r>{fmt(h.birim_fiyat)} {h.doviz}</Td>
              <Td r>%{h.kdv_orani}</Td>
              <Td r cls="font-semibold">{fmt(h.tutar)} {h.doviz}</Td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

// Tutari TL olarak yazar (0 ise '-')
function tlYaz(v) {
  if (!v || Math.abs(v) < 0.5) return '-'
  return Math.round(v).toLocaleString('tr-TR') + ' ₺'
}

// Doviz kirilimini tooltip metni yapar: '2.000 €  +  5.000 ₺'
function dvzAcikla(dovizler, alan) {
  const dv = dovizler || {}
  const parcalar = Object.keys(dv).map(k => {
    const r = dv[k] || {}
    const v = alan === 'kar' ? (r.gelir || 0) - (r.gider || 0) : (r[alan] || 0)
    if (Math.abs(v) < 0.5) return null
    return Math.round(v).toLocaleString('tr-TR') + ' ' + (k === 'TL' ? '₺' : k)
  }).filter(Boolean)
  return parcalar.length ? parcalar.join('  +  ') : ''
}

// Sefer ozeti: doviz bazli gelir/gider/kar + islem kuruyla TL karsiligi
function SeferOzet({ ozet }) {
  if (!ozet) return null
  const dv = ozet.dovizler || {}
  const kodlar = Object.keys(dv).filter(x => {
    const r = dv[x] || {}
    return Math.abs(r.gelir || 0) >= 0.5 || Math.abs(r.gider || 0) >= 0.5
  })
  if (!kodlar.length) return null
  const sym = (x) => (x === 'TL' ? '₺' : x)
  const fmt = (v, x) => `${Math.round(v || 0).toLocaleString('tr-TR')} ${sym(x)}`
  const cokDoviz = kodlar.length > 1 || (kodlar.length === 1 && kodlar[0] !== 'TL' && kodlar[0] !== '₺')
  const kart = (baslik, alan, renk) => (
    <div className="flex-1 min-w-[150px] rounded-lg border dark:border-gray-600 bg-white dark:bg-gray-800 px-3 py-2">
      <div className="text-[10px] uppercase tracking-wide text-gray-500 dark:text-gray-400">{baslik}</div>
      <div className={`text-sm font-semibold tabular-nums ${renk}`}>
        {kodlar.map(x => fmt(dv[x][alan], x)).join('  +  ')}
      </div>
      {cokDoviz && (
        <div className="text-[11px] text-gray-500 dark:text-gray-400 tabular-nums">
          = {Math.round(ozet[alan + '_tl'] || 0).toLocaleString('tr-TR')} ₺
        </div>
      )}
    </div>
  )
  return (
    <div className="mb-3">
      <div className="flex flex-wrap gap-2">
        {kart('Gelir', 'gelir', 'text-green-600 dark:text-green-400')}
        {kart('Gider', 'gider', 'text-red-600 dark:text-red-400')}
        {kart('Kar', 'kar', (ozet.kar_tl || 0) >= 0 ? 'text-emerald-700 dark:text-emerald-400' : 'text-red-700 dark:text-red-400')}
      </div>
      {ozet.uyari && (
        <div className="mt-1.5 text-[11px] text-amber-700 dark:text-amber-400 bg-amber-50 dark:bg-amber-900/20 border border-amber-200 dark:border-amber-800/50 rounded px-2 py-1">
          ⚠ {ozet.uyari}
        </div>
      )}
    </div>
  )
}

function SeferView({ d, onNavigate }) {
  if (!d) return null
  const k = d.kunye || {}
  const satir = (l, v, onClick) => (
    <div className="flex gap-2 py-0.5"><span className="text-gray-500 w-32 flex-shrink-0">{l}</span>
      <span className={`font-medium ${onClick ? 'text-blue-600 dark:text-blue-400 cursor-pointer hover:underline' : ''}`} onClick={onClick}>{v}</span></div>
  )
  return (
    <div>
      <SeferOzet ozet={d.ozet} />
      <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 mb-3 p-3 rounded-lg bg-slate-50 dark:bg-gray-700/40">
        {satir('Sefer No', `#${k.id}`)}
        {satir('Durum', k.durum)}
        {satir('Kayıt', k.kayit_tarihi)}
        {satir('Tip / Firma', `${k.tip} · ${k.firma}`)}
        {satir('Başlangıç', k.baslangic)}
        {satir('Bitiş', k.bitis)}
        {satir('Rota', k.rota)}
        {satir('Plaka', k.plaka, (k.plaka && k.plaka !== '-' && onNavigate) ? () => onNavigate({ type: 'arac', value: k.plaka }) : undefined)}
        {satir('Gönderici', k.gonderici)}
        {satir('Alıcı', k.alici)}
        {satir('Faturalanan', `${k.musteri} (${k.faturalanan})`)}
        {satir('Şoför', k.sofor)}
        {satir('Kaydeden', k.kaydeden)}
      </div>
      {(d.yukler || []).length > 0 && (
        <>
          <div className="text-[11px] font-semibold text-gray-600 dark:text-gray-300 mb-1">Yükler ({d.yukler.length})</div>
          <table className="w-full mb-3">
            <thead><tr><Th>Taşıma</Th><Th>Yük Cinsi</Th><Th>Gönderen</Th><Th>Alıcı</Th><Th r>KG</Th><Th r>Litre</Th><Th r>Kap</Th><Th>İrsaliye No</Th><Th>Açıklama</Th></tr></thead>
            <tbody>
              {d.yukler.map((y, i) => (
                <tr key={i} className="border-b border-gray-50 dark:border-gray-700 hover:bg-blue-50/30 dark:hover:bg-blue-900/20">
                  <Td>{onNavigate
                    ? <span onClick={() => onNavigate({ type: 'sefer_detay', value: String(y.sefer_detay_id) })}
                        className="text-blue-600 dark:text-blue-400 cursor-pointer hover:underline font-medium">#{y.sefer_detay_id}</span>
                    : `#${y.sefer_detay_id}`}</Td>
                  <Td>{y.cins}</Td>
                  <Td cls="truncate max-w-[160px]">{y.gonderen}</Td>
                  <Td cls="truncate max-w-[160px]">{y.alici}</Td>
                  <Td r cls="font-medium">{y.kg > 0 ? fmt(y.kg) : ''}</Td>
                  <Td r cls="font-medium">{y.lt > 0 ? fmt(y.lt) : ''}</Td>
                  <Td r>{y.kap > 0 ? fmt(y.kap) : ''}</Td>
                  <Td cls="text-gray-500">{y.irsaliye_no}</Td>
                  <Td cls="text-gray-500 truncate max-w-[180px]" title={y.aciklama}>{y.aciklama}</Td>
                </tr>
              ))}
            </tbody>
          </table>
        </>
      )}
      <div className="text-[11px] font-semibold text-gray-600 dark:text-gray-300 mb-1">Gelir / Gider Kalemleri ({(d.kalemler || []).length})</div>
      <table className="w-full">
        <thead><tr><Th>Tarih</Th><Th>Stok/Kalem</Th><Th>Açıklama</Th><Th r>Miktar</Th><Th r>Br.Fiyat</Th><Th r>Gider</Th><Th r>Gelir</Th></tr></thead>
        <tbody>
          {(d.kalemler || []).map((h, i) => (
            <tr key={i} className="border-b border-gray-50 dark:border-gray-700 hover:bg-blue-50/30 dark:hover:bg-blue-900/20">
              <Td>{h.tarih}</Td><Td>{h.stok}</Td><Td cls="text-gray-500">{h.aciklama}</Td>
              <Td r>{h.miktar ? `${fmt(h.miktar)} ${h.birim}` : ''}</Td>
              <Td r>{h.birim_fiyat ? (paraTL() && h.birim_fiyat_tl != null ? `${fmt(h.birim_fiyat_tl)} ₺` : `${fmt(h.birim_fiyat)} ${h.doviz}`) : ''}</Td>
              <Td r cls="text-red-600">{h.borc > 0 ? (paraTL() && h.borc_tl != null ? `${fmt(h.borc_tl)} ₺` : `${fmt(h.borc)} ${h.doviz}`) : ''}</Td>
              <Td r cls="text-green-600">{h.alacak > 0 ? (paraTL() && h.alacak_tl != null ? `${fmt(h.alacak_tl)} ₺` : `${fmt(h.alacak)} ${h.doviz}`) : ''}</Td>
            </tr>
          ))}
          {(d.kalemler || []).length === 0 && <tr><td colSpan={7} className="p-4 text-center text-gray-400">Gelir/gider kaydı yok</td></tr>}
        </tbody>
      </table>
    </div>
  )
}

function CariSeferlerView({ d, onNavigate }) {
  if (!d) return null
  const seferler = d.seferler || []
  return (
    <div>
      {d.unvan && onNavigate && (
        <div className="flex gap-1 mb-3">
          <button onClick={() => onNavigate({ type: 'cari', value: d.unvan })}
            className="px-3 py-1 rounded-lg text-xs font-medium bg-white dark:bg-gray-800 text-gray-600 dark:text-gray-300 border border-slate-200 dark:border-gray-600 hover:bg-slate-100 dark:hover:bg-gray-700">
            Bakiye
          </button>
          <span className="px-3 py-1 rounded-lg text-xs font-medium bg-slate-700 text-white">🚚 Seferler</span>
        </div>
      )}
      <div className="flex flex-wrap gap-2 mb-3">
        <div className="px-3 py-1.5 rounded-lg border dark:border-gray-600 bg-slate-50 dark:bg-gray-700/40">
          <div className="text-[10px] text-gray-500">Toplam Sefer</div>
          <div className="text-base font-bold tabular-nums">{d.sefer_sayisi || seferler.length}</div>
        </div>
      </div>
      <SeferOzet ozet={d.ozet} />
      <table className="w-full">
        <thead><tr><Th>Sefer No</Th><Th>Tarih</Th><Th>Tip</Th><Th>Durum</Th><Th>Plaka</Th><Th>Güzergah</Th><Th r>Gelir</Th><Th r>Gider</Th></tr></thead>
        <tbody>
          {seferler.map((s, i) => (
            <tr key={i} className="border-b border-gray-50 dark:border-gray-700 hover:bg-blue-50/30 dark:hover:bg-blue-900/20">
              <Td><span onClick={() => onNavigate && onNavigate({ type: 'sefer', value: s.sefer_no })}
                    className="text-blue-600 dark:text-blue-400 cursor-pointer hover:underline font-medium">#{s.sefer_no}</span></Td>
              <Td>{s.tarih}</Td>
              <Td cls="text-gray-500">{s.tip}</Td>
              <Td>{s.durum}</Td>
              <Td><span onClick={() => (s.plaka && s.plaka !== '-' && onNavigate) ? onNavigate({ type: 'arac', value: s.plaka }) : null}
                    className={s.plaka && s.plaka !== '-' ? 'text-blue-600 dark:text-blue-400 cursor-pointer hover:underline' : ''}>{s.plaka}</span></Td>
              <Td cls="text-gray-500 truncate max-w-[260px]">{s.guzergah}</Td>
              <Td r cls="tabular-nums text-green-600" title={dvzAcikla(s.dovizler, 'gelir')}>{tlYaz(s.gelir_tl)}</Td>
              <Td r cls="tabular-nums text-red-600" title={dvzAcikla(s.dovizler, 'gider')}>{tlYaz(s.gider_tl)}</Td>
              <Td r cls={`tabular-nums font-medium ${(s.kar_tl || 0) >= 0 ? 'text-emerald-700 dark:text-emerald-400' : 'text-red-700 dark:text-red-400'}`}
                  title={dvzAcikla(s.dovizler, 'kar')}>{tlYaz(s.kar_tl)}</Td>
            </tr>
          ))}
          {seferler.length === 0 && <tr><td colSpan={9} className="p-4 text-center text-gray-400">Sefer bulunamadı</td></tr>}
        </tbody>
      </table>
    </div>
  )
}

function SeferDetayView({ d, onNavigate }) {
  if (!d) return null
  const k = d.kunye || {}
  const satir = (l, v, onClick) => (
    <div className="flex gap-2 py-0.5"><span className="text-gray-500 w-32 flex-shrink-0">{l}</span>
      <span className={`font-medium ${onClick ? 'text-blue-600 dark:text-blue-400 cursor-pointer hover:underline' : ''}`} onClick={onClick}>{v}</span></div>
  )
  return (
    <div>
      <div className="flex flex-wrap gap-2 mb-3">
        <div className="px-3 py-1.5 rounded-lg border dark:border-gray-600 bg-green-50 dark:bg-green-900/20">
          <div className="text-[10px] text-gray-500">Gelir</div><div className="text-sm font-bold text-green-700 dark:text-green-400">{fmtPara(d.gelir_dvz, d.gelir_tl)}</div>
        </div>
        <div className="px-3 py-1.5 rounded-lg border dark:border-gray-600 bg-red-50 dark:bg-red-900/20">
          <div className="text-[10px] text-gray-500">Gider</div><div className="text-sm font-bold text-red-700 dark:text-red-400">{fmtPara(d.gider_dvz, d.gider_tl)}</div>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 mb-3 p-3 rounded-lg bg-slate-50 dark:bg-gray-700/40">
        {satir('Taşıma No', `#${k.id}`)}
        {satir('Ait Olduğu Sefer', `#${k.id_sefer}`, (k.id_sefer && onNavigate) ? () => onNavigate({ type: 'sefer', value: k.id_sefer }) : undefined)}
        {satir('Plaka', k.plaka, (k.plaka && k.plaka !== '-' && onNavigate) ? () => onNavigate({ type: 'arac', value: k.plaka }) : undefined)}
        {satir('Yön', k.yon)}
        {satir('Güzergah', k.guzergah)}
        {satir('Fatura', k.fatura)}
        {satir('Gönderen', k.gonderen)}
        {satir('Alıcı', k.alici)}
        {satir('Faturalanan', `${k.musteri} (${k.faturalanan})`)}
      </div>
      <div className="text-[11px] font-semibold text-gray-600 dark:text-gray-300 mb-1">Gelir / Gider Kalemleri ({(d.kalemler || []).length})</div>
      <table className="w-full">
        <thead><tr><Th>Tarih</Th><Th>Stok/Kalem</Th><Th>Açıklama</Th><Th r>Miktar</Th><Th r>Br.Fiyat</Th><Th r>Gider</Th><Th r>Gelir</Th></tr></thead>
        <tbody>
          {(d.kalemler || []).map((h, i) => (
            <tr key={i} className="border-b border-gray-50 dark:border-gray-700 hover:bg-blue-50/30 dark:hover:bg-blue-900/20">
              <Td>{h.tarih}</Td><Td>{h.stok}</Td><Td cls="text-gray-500">{h.aciklama}</Td>
              <Td r>{h.miktar ? `${fmt(h.miktar)} ${h.birim}` : ''}</Td>
              <Td r>{h.birim_fiyat ? (paraTL() && h.birim_fiyat_tl != null ? `${fmt(h.birim_fiyat_tl)} ₺` : `${fmt(h.birim_fiyat)} ${h.doviz}`) : ''}</Td>
              <Td r cls="text-red-600">{h.borc > 0 ? (paraTL() && h.borc_tl != null ? `${fmt(h.borc_tl)} ₺` : `${fmt(h.borc)} ${h.doviz}`) : ''}</Td>
              <Td r cls="text-green-600">{h.alacak > 0 ? (paraTL() && h.alacak_tl != null ? `${fmt(h.alacak_tl)} ₺` : `${fmt(h.alacak)} ${h.doviz}`) : ''}</Td>
            </tr>
          ))}
          {(d.kalemler || []).length === 0 && <tr><td colSpan={7} className="p-4 text-center text-gray-400">Gelir/gider kaydı yok</td></tr>}
        </tbody>
      </table>
    </div>
  )
}

function PetrolCariView({ d }) {
  if (!d) return null
  // En yakın tarihten en uzağa (yeniden eskiye) sırala
  const hareketler = [...(d.data || [])].sort((a, b) =>
    String(b.TARIH || '').localeCompare(String(a.TARIH || '')))
  const ozet = d.istasyon_ozet || []
  const devir = d.devir_bakiye || 0
  const _ok = ozet.filter(o => !o.hata)
  // 3 istasyon TOPLAM (hatalı/erişilemeyen istasyonlar hariç): genel = devir dahil, dönem = devirsiz
  const toplamGenel = _ok.reduce((s, o) => s + (o.bakiye || 0), 0)
  const toplamDonem = _ok.reduce((s, o) => s + ((o.bakiye || 0) - (o.devir || 0)), 0)
  const ikiSatir = (donemV, genelV) => (
    <>
      <div className="flex items-baseline justify-between gap-3">
        <span className="text-[9px] text-gray-400">Dönem</span>
        <span className={`text-xs font-medium tabular-nums ${donemV > 0 ? 'text-red-600' : 'text-green-600'}`}>{fmt(donemV)} ₺</span>
      </div>
      <div className="flex items-baseline justify-between gap-3 border-t border-gray-200 dark:border-gray-600 mt-0.5 pt-0.5">
        <span className="text-[9px] text-gray-400">Genel</span>
        <span className={`text-sm font-bold tabular-nums ${genelV > 0 ? 'text-red-700' : 'text-green-700'}`}>{fmt(genelV)} ₺</span>
      </div>
    </>
  )
  return (
    <div>
      <div className="flex flex-wrap gap-2 mb-3">
        {ozet.map(o => (
          <div key={o.istasyon} className={`px-3 py-1.5 rounded-lg border dark:border-gray-600 min-w-[150px] ${o.hata ? 'bg-red-50 border-red-200' : 'bg-slate-50 dark:bg-gray-700/40'}`}>
            <div className="text-[10px] text-gray-500">{o.istasyon}</div>
            {o.hata ? <div className="text-xs text-red-500">erişilemedi</div>
              : ikiSatir((o.bakiye || 0) - (o.devir || 0), o.bakiye || 0)}
            {!o.hata && <div className="text-[9px] text-gray-400 mt-0.5">{o.hareket} hareket</div>}
          </div>
        ))}
        {_ok.length > 1 && (
          <div className="px-3 py-1.5 rounded-lg border-2 border-blue-300 dark:border-blue-700 bg-blue-50 dark:bg-blue-900/30 min-w-[160px]">
            <div className="text-[10px] text-blue-700 dark:text-blue-300 font-semibold">TOPLAM ({_ok.length} İstasyon)</div>
            {ikiSatir(toplamDonem, toplamGenel)}
          </div>
        )}
        {ozet.length === 0 && devir !== 0 && (
          <div className="px-3 py-1.5 rounded-lg border dark:border-gray-600 bg-slate-50 dark:bg-gray-700/40">
            <div className="text-[10px] text-gray-500">Devir Bakiye</div>
            <div className={`text-sm font-bold ${devir > 0 ? 'text-red-600' : 'text-green-600'}`}>{fmt(devir)} ₺</div>
          </div>
        )}
      </div>
      <PetrolHareketAgaci hareketler={hareketler} />
    </div>
  )
}

// Karlılıkta ürüne tıklanınca: o ürünün son alış faturaları (istasyon seçilebilir)
function PetrolAlisView({ d: dIlk }) {
  const [sube, setSube] = useState('')
  const [d, setD] = useState(dIlk)
  const [yukleniyor, setYukleniyor] = useState(false)
  useEffect(() => { setD(dIlk); setSube('') }, [dIlk])
  const subeSec = (s) => {
    setSube(s); setYukleniyor(true)
    api.get(`/petrol-son-alis/_?urun_q=${encodeURIComponent(dIlk?.urun || '')}${s ? `&sube=${s}` : ''}`)
      .then(({ data }) => setD(data))
      .catch(() => {})
      .finally(() => setYukleniyor(false))
  }
  if (!d) return null
  const alislar = d.data || []
  const subeBtn = ([k, l]) => (
    <button key={k} onClick={() => subeSec(k)}
      className={`px-2.5 py-1 rounded font-medium text-[11px] ${sube === k ? 'bg-slate-700 text-white' : 'bg-white dark:bg-gray-800 text-gray-600 dark:text-gray-300 border border-slate-200 dark:border-gray-600'}`}>
      {l}
    </button>
  )
  return (
    <div>
      <div className="flex items-center gap-1.5 mb-2">
        {[['', 'Tüm İstasyonlar'], ['altinekin', 'Altınekin'], ['tatlicak', 'Tatlıcak'], ['ladik', 'Ladık']].map(subeBtn)}
        {yukleniyor && <span className="text-[11px] text-gray-400 ml-1">yükleniyor…</span>}
      </div>
      {alislar.length === 0 && !yukleniyor && <div className="p-6 text-center text-gray-400">Alış kaydı bulunamadı</div>}
      <div className="flex flex-wrap gap-2 mb-3">
        <div className="px-3 py-1.5 rounded-lg border dark:border-gray-600 bg-blue-50 dark:bg-blue-900/15">
          <div className="text-[10px] text-gray-500">Son Alış Fiyatı (KDV'li)</div>
          <div className="text-base font-bold tabular-nums text-blue-700 dark:text-blue-300">{fmt(d.son_fiyat)} ₺</div>
        </div>
        <div className="px-3 py-1.5 rounded-lg border dark:border-gray-600 bg-slate-50 dark:bg-gray-700/40">
          <div className="text-[10px] text-gray-500">Listelenen {d.row_count} Alış</div>
          <div className="text-sm font-bold tabular-nums">{fmt(d.toplam_litre)} lt · {fmt(d.toplam_tutar)} ₺</div>
        </div>
      </div>
      <table className="w-full">
        <thead><tr><Th>Tarih</Th><Th>İstasyon</Th><Th>Stok</Th><Th>Tedarikçi</Th><Th>Evrak No</Th><Th r>Miktar (lt)</Th><Th r>Birim Fiyat</Th><Th r>Tutar</Th></tr></thead>
        <tbody>
          {alislar.map((h, i) => (
            <tr key={i} className="border-b border-gray-50 dark:border-gray-700 hover:bg-blue-50/30 dark:hover:bg-blue-900/20">
              <Td>{String(h.TARIH || '').substring(0, 10)}</Td>
              <Td cls="text-gray-500">{h.ISTASYON}</Td>
              <Td cls="truncate max-w-[140px]">{h.STOK}</Td>
              <Td cls="truncate max-w-[200px]">{h.TEDARIKCI}</Td>
              <Td cls="text-gray-500">{h.EVRAK_NO}</Td>
              <Td r cls="font-medium">{fmt(h.MIKTAR)}</Td>
              <Td r>{fmt(h.FIYAT)}</Td>
              <Td r cls="text-blue-700 dark:text-blue-300 font-medium">{fmt(h.TUTAR)} ₺</Td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

// Müşteri hesap ekstresi — cari hareket defteri (Bakiye Raporu ile aynı kaynak).
// BORÇ = satış/fatura, ALACAK = tahsilat/havale; yanda yürüyen BAKİYE (renkle: kırmızı borçlu / yeşil alacaklı).
// Petrol cari hareket işlem türü kodları -> okunabilir Türkçe
const PETROL_ISLEM_AD = {
  POMPASatis: 'Pompa Satış', posgelir: 'POS Tahsilat', gelenhav: 'Gelen Havale',
  satmalfat: 'Satış Faturası', satmalfisi: 'Satış Fişi', alnmalfat: 'Alış Faturası',
  alnmalfisi: 'Alış Fişi', virman: 'Virman', 'ödeme': 'Ödeme', odeme: 'Ödeme',
  tahsilat: 'Tahsilat', cekilen: 'Çekilen', alncek: 'Alınan Çek',
  balacdev: 'Devir (Alacak)', bborcdev: 'Devir (Borç)', AlckDekont: 'Alacak Dekont',
}
const _petrolIslemAd = (t) => PETROL_ISLEM_AD[String(t || '').trim()] || String(t || '-')

function PetrolSatisView({ d }) {
  const [acik, setAcik] = useState({})
  const [subeF, setSubeF] = useState('')  // client-side istasyon filtresi (anlik gecis)
  const [islemF, setIslemF] = useState('')  // client-side işlem türü filtresi
  if (!d) return null
  const uOzet = d.urun_ozet || []
  const fmtL = (v) => `${fmt(v)} lt`
  const hrk = d.hareketler || []
  if (hrk.length === 0)
    return <div className="p-6 text-center text-gray-400">Bu müşterinin cari hareketi bulunamadı</div>

  const mevcutSubeler = [...new Set(hrk.map(h => h.ISTASYON).filter(Boolean))]
  // Mevcut işlem türleri (işlem sayısına göre azalan) — filtre dropdown'u için
  const _islemSay = {}
  hrk.forEach(h => { const a = _petrolIslemAd(h.TUR_AD || h.TUR); _islemSay[a] = (_islemSay[a] || 0) + 1 })
  const mevcutIslemler = Object.keys(_islemSay).sort((a, b) => _islemSay[b] - _islemSay[a])
  let hareketler = hrk.map(h => ({
    zaman: String(h.ZAMAN || ''), istasyon: h.ISTASYON || '',
    islem: _petrolIslemAd(h.TUR_AD || h.TUR), tip: (Number(h.BORC) || 0) > 0 ? 'borc' : 'alacak',
    detay: h.ACIKLAMA || '', borc: Number(h.BORC) || 0, alacak: Number(h.ALACAK) || 0,
  }))
  if (subeF) hareketler = hareketler.filter(h => h.istasyon === subeF)
  if (islemF) hareketler = hareketler.filter(h => h.islem === islemF)
  hareketler.sort((a, b) => a.zaman.localeCompare(b.zaman) || (b.borc - a.borc))  // eski→yeni
  const devir = subeF ? 0 : (Number(d.devir_bakiye) || 0)  // istasyon secilince devir yok (o istasyonun periyodu)
  let _bak = devir
  hareketler.forEach(h => { _bak += h.borc - h.alacak; h.bakiye = _bak })
  const toplamBorc = d.toplam_borc ?? hareketler.reduce((s, h) => s + h.borc, 0)
  const toplamAlacak = d.toplam_alacak ?? hareketler.reduce((s, h) => s + h.alacak, 0)
  const netBakiye = devir + toplamBorc - toplamAlacak

  const grup = {}
  hareketler.forEach(h => {
    const y = h.zaman.slice(0, 4) || '?'; const a = h.zaman.slice(0, 7) || '?'
    if (!grup[y]) grup[y] = {}
    if (!grup[y][a]) grup[y][a] = []
    grup[y][a].push(h)
  })
  const yillar = Object.keys(grup).sort().reverse()
  const enYeniYil = yillar[0]
  const enYeniAy = enYeniYil ? Object.keys(grup[enYeniYil]).sort().reverse()[0] : null
  const acikMi = (k, dv) => (acik[k] === undefined ? dv : acik[k])
  const tgl = (k, dv) => setAcik(p => ({ ...p, [k]: !acikMi(k, dv) }))
  const sumB = (rows) => rows.reduce((s, h) => s + h.borc, 0)
  const sumA = (rows) => rows.reduce((s, h) => s + h.alacak, 0)
  const kapanis = (rows) => { let mx = null; rows.forEach(h => { if (!mx || h.zaman > mx.zaman) mx = h }); return mx ? mx.bakiye : 0 }
  const bakCls = (v) => v > 0.5 ? 'text-red-700 dark:text-red-400' : v < -0.5 ? 'text-green-700 dark:text-green-400' : 'text-gray-500'
  // Bakiye: eksi işareti YOK — renk yönü belirtir (kırmızı=borçlu, yeşil=alacaklı)
  const bakStr = (v) => `${fmt(Math.abs(v))} ₺`

  return (
    <div>
      {mevcutSubeler.length > 1 && (
        <div className="flex items-center gap-1.5 mb-2">
          {[['', 'Tüm İstasyonlar'], ...mevcutSubeler.map(x => [x, x])].map(([k, l]) => (
            <button key={k} onClick={() => setSubeF(k)}
              className={`px-2.5 py-1 rounded font-medium text-[11px] ${subeF === k ? 'bg-slate-700 text-white' : 'bg-white dark:bg-gray-800 text-gray-600 dark:text-gray-300 border border-slate-200 dark:border-gray-600'}`}>
              {l}
            </button>
          ))}
        </div>
      )}
      {mevcutIslemler.length > 1 && (
        <div className="flex items-center gap-1.5 mb-2 flex-wrap">
          <span className="text-[10px] text-gray-400 font-medium">İşlem:</span>
          <button onClick={() => setIslemF('')}
            className={`px-2.5 py-1 rounded font-medium text-[11px] ${islemF === '' ? 'bg-slate-700 text-white' : 'bg-white dark:bg-gray-800 text-gray-600 dark:text-gray-300 border border-slate-200 dark:border-gray-600'}`}>
            Tümü
          </button>
          {mevcutIslemler.map(t => (
            <button key={t} onClick={() => setIslemF(t)}
              className={`px-2.5 py-1 rounded font-medium text-[11px] ${islemF === t ? 'bg-slate-700 text-white' : 'bg-white dark:bg-gray-800 text-gray-600 dark:text-gray-300 border border-slate-200 dark:border-gray-600'}`}>
              {t} <span className="opacity-60">({_islemSay[t]})</span>
            </button>
          ))}
        </div>
      )}
      <div className="flex flex-wrap gap-2 mb-3">
        {Math.abs(devir) > 0.5 && (
          <div className="px-3 py-1.5 rounded-lg border border-dashed border-amber-300 dark:border-amber-700 bg-amber-50 dark:bg-amber-900/15 min-w-[130px]">
            <div className="text-[10px] text-gray-500">Devir Bakiye (önceki)</div>
            <div className={`text-sm font-bold tabular-nums ${bakCls(devir)}`}>{bakStr(devir)}</div>
          </div>
        )}
        {uOzet.map(u => (
          <div key={u.urun} className="px-3 py-1.5 rounded-lg border dark:border-gray-600 bg-blue-50 dark:bg-blue-900/15 min-w-[130px]">
            <div className="text-[10px] text-gray-500">{u.urun} (satış)</div>
            <div className="text-sm font-bold tabular-nums text-blue-700 dark:text-blue-300">{fmt(u.tutar)} ₺</div>
            <div className="text-[10px] text-gray-400">{fmtL(u.litre)} · {u.islem} işlem</div>
          </div>
        ))}
        <div className="px-3 py-1.5 rounded-lg border border-red-200 dark:border-red-800 bg-red-50 dark:bg-red-900/15 min-w-[120px]">
          <div className="text-[10px] text-gray-500">Toplam Borç</div>
          <div className="text-sm font-bold tabular-nums text-red-700 dark:text-red-300">{fmt(toplamBorc)} ₺</div>
        </div>
        <div className="px-3 py-1.5 rounded-lg border border-green-200 dark:border-green-800 bg-green-50 dark:bg-green-900/15 min-w-[120px]">
          <div className="text-[10px] text-gray-500">Toplam Alacak</div>
          <div className="text-sm font-bold tabular-nums text-green-700 dark:text-green-300">{fmt(toplamAlacak)} ₺</div>
        </div>
        <div className="px-3 py-1.5 rounded-lg border-2 border-slate-300 dark:border-slate-600 bg-slate-50 dark:bg-gray-700/40 min-w-[130px]">
          <div className="text-[10px] text-gray-500">Bakiye</div>
          <div className={`text-sm font-bold tabular-nums ${bakCls(netBakiye)}`}>{bakStr(netBakiye)}</div>
          <div className={`text-[10px] font-medium ${bakCls(netBakiye)}`}>{netBakiye > 0.5 ? 'Borçlu' : netBakiye < -0.5 ? 'Alacaklı' : 'Kapalı'}</div>
        </div>
      </div>
      <table className="w-full">
        <thead><tr><Th>Tarih</Th><Th>İşlem</Th><Th>Detay</Th><Th r>Borç</Th><Th r>Alacak</Th><Th r>Bakiye</Th></tr></thead>
        <tbody>
          {yillar.flatMap(y => {
            const yk = `y${y}`; const yAcik = acikMi(yk, y === enYeniYil)
            const yRows = Object.values(grup[y]).flat()
            const out = [(
              <tr key={yk} onClick={() => tgl(yk, y === enYeniYil)}
                className="bg-slate-200 dark:bg-slate-700 cursor-pointer hover:bg-slate-300 dark:hover:bg-slate-600 select-none">
                <Td cls="font-bold whitespace-nowrap">{yAcik ? '▾' : '▸'} {y} ({yRows.length})</Td>
                <Td /><Td />
                <Td r cls="font-bold text-red-600">{sumB(yRows) > 0.5 ? `${fmt(sumB(yRows))} ₺` : ''}</Td>
                <Td r cls="font-bold text-green-600">{sumA(yRows) > 0.5 ? `${fmt(sumA(yRows))} ₺` : ''}</Td>
                <Td r cls={`font-bold ${bakCls(kapanis(yRows))}`}>{bakStr(kapanis(yRows))}</Td>
              </tr>
            )]
            if (!yAcik) return out
            Object.keys(grup[y]).sort().reverse().forEach(a => {
              const ak = `a${a}`; const aAcik = acikMi(ak, a === enYeniAy)
              const rows = [...grup[y][a]].sort((x, z) => z.zaman.localeCompare(x.zaman))
              const ayNo = parseInt(a.split('-')[1]) || 0
              out.push(
                <tr key={ak} onClick={() => tgl(ak, a === enYeniAy)}
                  className="bg-gray-50 dark:bg-gray-700/50 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700 select-none">
                  <Td cls="pl-4 font-semibold text-gray-600 dark:text-gray-300 whitespace-nowrap">{aAcik ? '▾' : '▸'} {AY_ADI[ayNo] || a} ({rows.length})</Td>
                  <Td /><Td />
                  <Td r cls="font-medium text-red-500">{sumB(rows) > 0.5 ? `${fmt(sumB(rows))} ₺` : ''}</Td>
                  <Td r cls="font-medium text-green-500">{sumA(rows) > 0.5 ? `${fmt(sumA(rows))} ₺` : ''}</Td>
                  <Td r cls={`font-medium ${bakCls(kapanis(rows))}`}>{bakStr(kapanis(rows))}</Td>
                </tr>
              )
              if (aAcik) rows.forEach((h, i) => out.push(
                <tr key={`${ak}-${i}`} className="border-b border-gray-50 dark:border-gray-700 hover:bg-blue-50/30 dark:hover:bg-blue-900/20">
                  <Td cls="pl-7 whitespace-nowrap">{h.zaman.substring(0, 10)}{h.zaman.length > 11 ? ' ' + h.zaman.substring(11, 16) : ''}</Td>
                  <Td>{h.tip === 'borc'
                    ? <span className="px-1.5 py-0.5 rounded text-[10px] font-medium bg-blue-100 text-blue-700 dark:bg-blue-900/40 dark:text-blue-300 whitespace-nowrap">{h.islem}</span>
                    : <span className="px-1.5 py-0.5 rounded text-[10px] font-medium bg-green-100 text-green-700 dark:bg-green-900/40 dark:text-green-300 whitespace-nowrap">{h.islem}</span>}</Td>
                  <Td cls="text-gray-500 truncate max-w-[220px]" title={`${h.istasyon} · ${h.detay}`}>{h.istasyon}{h.detay ? ` · ${h.detay}` : ''}</Td>
                  <Td r cls="text-red-600">{h.borc > 0.5 ? `${fmt(h.borc)} ₺` : ''}</Td>
                  <Td r cls="text-green-600">{h.alacak > 0.5 ? `${fmt(h.alacak)} ₺` : ''}</Td>
                  <Td r cls={`font-medium ${bakCls(h.bakiye)}`}>{bakStr(h.bakiye)}</Td>
                </tr>
              ))
            })
            return out
          })}
          {Math.abs(devir) > 0.5 && (
            <tr className="bg-amber-50 dark:bg-amber-900/15 border-t-2 border-amber-200 dark:border-amber-800">
              <Td cls="font-semibold text-amber-700 dark:text-amber-300 whitespace-nowrap">↳ Devir Bakiye (dönem öncesi)</Td>
              <Td /><Td /><Td /><Td />
              <Td r cls={`font-bold ${bakCls(devir)}`}>{bakStr(devir)}</Td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  )
}

// Tahsilatlar (havale/POS/nakit): yıl → ay hiyerarşisi
function TahsilatAgaci({ tahsilatlar }) {
  const [acik, setAcik] = useState({})
  const grup = {}
  tahsilatlar.forEach(t => {
    const z = String(t.ZAMAN || ''); const y = z.slice(0, 4) || '?'; const a = z.slice(0, 7) || '?'
    if (!grup[y]) grup[y] = {}
    if (!grup[y][a]) grup[y][a] = []
    grup[y][a].push(t)
  })
  const yillar = Object.keys(grup).sort().reverse()
  const enYeniYil = yillar[0]
  const enYeniAy = enYeniYil ? Object.keys(grup[enYeniYil]).sort().reverse()[0] : null
  const acikMi = (k, d) => (acik[k] === undefined ? d : acik[k])
  const tgl = (k, d) => setAcik(p => ({ ...p, [k]: !acikMi(k, d) }))
  const top = (rows) => rows.reduce((s, t) => s + (Number(t.TUTAR) || 0), 0)
  return (
    <table className="w-full">
      <thead><tr><Th>Tarih</Th><Th>İstasyon</Th><Th>Tür</Th><Th>Açıklama</Th><Th r>Tutar</Th></tr></thead>
      <tbody>
        {yillar.flatMap(y => {
          const yk = `ty${y}`; const yAcik = acikMi(yk, y === enYeniYil)
          const yRows = Object.values(grup[y]).flat()
          const out = [(
            <tr key={yk} onClick={() => tgl(yk, y === enYeniYil)}
              className="bg-slate-200 dark:bg-slate-700 cursor-pointer hover:bg-slate-300 dark:hover:bg-slate-600 select-none">
              <Td cls="font-bold whitespace-nowrap">{yAcik ? '▾' : '▸'} {y} ({yRows.length})</Td>
              <Td /><Td /><Td />
              <Td r cls="font-bold text-green-700 dark:text-green-300">{fmt(top(yRows))} ₺</Td>
            </tr>
          )]
          if (!yAcik) return out
          Object.keys(grup[y]).sort().reverse().forEach(a => {
            const ak = `ta${a}`; const aAcik = acikMi(ak, a === enYeniAy)
            const rows = grup[y][a]
            const ayNo = parseInt(a.split('-')[1]) || 0
            out.push(
              <tr key={ak} onClick={() => tgl(ak, a === enYeniAy)}
                className="bg-gray-50 dark:bg-gray-700/50 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700 select-none">
                <Td cls="pl-4 font-semibold text-gray-600 dark:text-gray-300 whitespace-nowrap">{aAcik ? '▾' : '▸'} {AY_ADI[ayNo] || a} ({rows.length})</Td>
                <Td /><Td /><Td />
                <Td r cls="font-medium text-green-600 dark:text-green-400">{fmt(top(rows))} ₺</Td>
              </tr>
            )
            if (aAcik) rows.forEach((t, i) => out.push(
              <tr key={`${ak}-${i}`} className="border-b border-gray-50 dark:border-gray-700 hover:bg-green-50/30 dark:hover:bg-green-900/10">
                <Td cls="pl-7 whitespace-nowrap">{String(t.ZAMAN || '').substring(0, 10)}</Td>
                <Td cls="text-gray-500">{t.ISTASYON}</Td>
                <Td><span className="px-1.5 py-0.5 rounded text-[10px] font-medium bg-green-100 text-green-700 dark:bg-green-900/40 dark:text-green-300 whitespace-nowrap">{t.TUR_AD}</span></Td>
                <Td cls="text-gray-500 truncate max-w-[240px]" title={t.ACIKLAMA}>{t.ACIKLAMA}</Td>
                <Td r cls="text-green-600 font-medium">{fmt(t.TUTAR)} ₺</Td>
              </tr>
            ))
          })
          return out
        })}
      </tbody>
    </table>
  )
}

// Petrol cari hareketleri: yıl → ay hiyerarşisi (en yeni yıl+ay açık)
function PetrolHareketAgaci({ hareketler }) {
  const [acik, setAcik] = useState({})
  if (hareketler.length === 0)
    return <div className="p-4 text-center text-gray-400">Hareket bulunamadı</div>
  const grup = {}
  hareketler.forEach(h => {
    const t = String(h.TARIH || ''); const y = t.slice(0, 4) || '?'; const a = t.slice(0, 7) || '?'
    if (!grup[y]) grup[y] = {}
    if (!grup[y][a]) grup[y][a] = []
    grup[y][a].push(h)
  })
  const yillar = Object.keys(grup).sort().reverse()
  const enYeniYil = yillar[0]
  const enYeniAy = Object.keys(grup[enYeniYil] || {}).sort().reverse()[0]
  const acikMi = (k, defAcik) => (acik[k] === undefined ? defAcik : acik[k])
  const tgl = (k, defAcik) => setAcik(p => ({ ...p, [k]: !acikMi(k, defAcik) }))
  const topla = (rows, alan) => {
    const v = rows.reduce((s, h) => s + (Number(h[alan]) || 0), 0)
    return v > 0.004 ? `${fmt(v)} ₺` : ''
  }
  return (
    <table className="w-full">
      <thead><tr><Th>Tarih</Th><Th>İstasyon</Th><Th>İşlem Türü</Th><Th r>Borç</Th><Th r>Alacak</Th><Th r>Dönem Bakiye</Th><Th r>Genel Bakiye</Th><Th>Açıklama</Th></tr></thead>
      <tbody>
        {yillar.flatMap(y => {
          const yk = `y${y}`; const yAcik = acikMi(yk, y === enYeniYil)
          const yRows = Object.values(grup[y]).flat()
          const out = [(
            <tr key={yk} onClick={() => tgl(yk, y === enYeniYil)}
              className="bg-slate-200 dark:bg-slate-700 cursor-pointer hover:bg-slate-300 dark:hover:bg-slate-600 select-none">
              <Td cls="font-bold whitespace-nowrap">{yAcik ? '▾' : '▸'} {y} ({yRows.length})</Td>
              <Td /><Td />
              <Td r cls="text-red-600 font-bold">{topla(yRows, 'BORC')}</Td>
              <Td r cls="text-green-600 font-bold">{topla(yRows, 'ALACAK')}</Td>
              <Td /><Td /><Td />
            </tr>
          )]
          if (!yAcik) return out
          Object.keys(grup[y]).sort().reverse().forEach(a => {
            const ak = `a${a}`; const aAcik = acikMi(ak, a === enYeniAy)
            const rows = grup[y][a]
            const ayNo = parseInt(a.split('-')[1]) || 0
            out.push(
              <tr key={ak} onClick={() => tgl(ak, a === enYeniAy)}
                className="bg-gray-50 dark:bg-gray-700/50 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700 select-none">
                <Td cls="pl-4 font-semibold text-gray-600 dark:text-gray-300 whitespace-nowrap">{aAcik ? '▾' : '▸'} {AY_ADI[ayNo] || a} ({rows.length})</Td>
                <Td /><Td />
                <Td r cls="text-red-500 font-medium">{topla(rows, 'BORC')}</Td>
                <Td r cls="text-green-500 font-medium">{topla(rows, 'ALACAK')}</Td>
                <Td /><Td /><Td />
              </tr>
            )
            if (aAcik) rows.forEach((h, i) => out.push(
              <tr key={`${ak}-${i}`} className="border-b border-gray-50 dark:border-gray-700 hover:bg-blue-50/30 dark:hover:bg-blue-900/20">
                <Td cls="pl-7 whitespace-nowrap">{String(h.TARIH || '').substring(0, 10)}</Td>
                <Td cls="text-gray-500">{h.ISTASYON || ''}</Td>
                <Td>{h.ISLEM_TURU || ''}</Td>
                <Td r cls="text-red-600">{h.BORC > 0 ? fmt(h.BORC) : ''}</Td>
                <Td r cls="text-green-600">{h.ALACAK > 0 ? fmt(h.ALACAK) : ''}</Td>
                <Td r cls={(h.DONEM_BAKIYE || 0) > 0 ? 'text-red-600' : 'text-green-600'}>{fmt(h.DONEM_BAKIYE)}</Td>
                <Td r cls={(h.KUMULATIF_BAKIYE || 0) > 0 ? 'text-red-700 font-semibold' : 'text-green-700 font-semibold'}>{fmt(h.KUMULATIF_BAKIYE)}</Td>
                <Td cls="text-gray-500 truncate max-w-[260px]">{h.ACIKLAMA || ''}</Td>
              </tr>
            ))
          })
          return out
        })}
      </tbody>
    </table>
  )
}

// Aylık Alacak ve Kar grafiğinde aya tıklanınca: o ayın tüm gelir/gider işlemleri (İşlem Yeri'ne göre)
function AyView({ d, onNavigate }) {
  if (!d) return null
  const islemler = d.islemler || []
  // Doviz kirilimini sadece TL disinda doviz varsa goster (tek ₺ iken TL karsiligiyla ayni)
  const cokDvz = (obj) => Object.keys(obj || {}).some(k => !['₺', 'TL'].includes(k))
  return (
    <div>
      <div className="flex flex-wrap gap-2 mb-3">
        <div className="px-3 py-1.5 rounded-lg border dark:border-gray-600 bg-blue-50 dark:bg-blue-900/15">
          <div className="text-[10px] text-gray-500">Gelir (TL karşılığı)</div>
          <div className="text-base font-bold tabular-nums text-blue-600">{fmt(d.gelir_tl)} ₺</div>
          {cokDvz(d.gelir_dvz) && <div className="text-[10px] text-gray-400">{fmtDvz(d.gelir_dvz)}</div>}
        </div>
        <div className="px-3 py-1.5 rounded-lg border dark:border-gray-600 bg-red-50 dark:bg-red-900/15">
          <div className="text-[10px] text-gray-500">Gider (TL karşılığı)</div>
          <div className="text-base font-bold tabular-nums text-red-600">{fmt(d.gider_tl)} ₺</div>
          {cokDvz(d.gider_dvz) && <div className="text-[10px] text-gray-400">{fmtDvz(d.gider_dvz)}</div>}
        </div>
        <div className="px-3 py-1.5 rounded-lg border dark:border-gray-600 bg-slate-50 dark:bg-gray-700/40">
          <div className="text-[10px] text-gray-500">Net Kâr</div>
          <div className={`text-base font-bold tabular-nums ${d.kar_tl >= 0 ? 'text-green-600' : 'text-red-600'}`}>{fmt(d.kar_tl)} ₺</div>
        </div>
        <div className="px-3 py-1.5 rounded-lg border border-dashed dark:border-gray-600">
          <div className="text-[10px] text-gray-500">İşlem Sayısı</div>
          <div className="text-base font-bold tabular-nums">{islemler.length}</div>
        </div>
      </div>
      <table className="w-full">
        <thead><tr><Th>Tarih</Th><Th>Tür</Th><Th>Kalem</Th><Th>Cari</Th><Th>Plaka</Th><Th r>Sefer</Th><Th r>Gelir</Th><Th r>Gider</Th><Th>Açıklama</Th></tr></thead>
        <tbody>
          {islemler.map((h, i) => (
            <tr key={i} className="border-b border-gray-50 dark:border-gray-700 hover:bg-blue-50/30 dark:hover:bg-blue-900/20">
              <Td>{h.tarih}</Td>
              <Td cls={h.alacak > 0 ? 'text-green-600 font-medium' : 'text-gray-500'}>{h.tur}</Td>
              <Td cls="truncate max-w-[160px]" >{h.stok}</Td>
              <Td cls="truncate max-w-[180px]">{h.cari}</Td>
              <Td>{h.plaka || <span className="text-gray-400">—</span>}</Td>
              <Td r>{h.sefer_id
                ? <span onClick={() => onNavigate && onNavigate({ type: 'sefer', value: String(h.sefer_id) })}
                    className="text-blue-600 dark:text-blue-400 cursor-pointer hover:underline font-medium">#{h.sefer_id}</span>
                : <span className="text-gray-400">—</span>}</Td>
              <Td r cls="text-green-600">{h.alacak > 0 ? `${fmt(h.alacak)} ${h.doviz}` : ''}</Td>
              <Td r cls="text-red-600">{h.borc > 0 ? `${fmt(h.borc)} ${h.doviz}` : ''}</Td>
              <Td cls="truncate max-w-[220px] text-gray-500">{h.aciklama}</Td>
            </tr>
          ))}
        </tbody>
      </table>
      {islemler.length === 0 && <div className="p-6 text-center text-gray-400">Bu ayda işlem yok</div>}
    </div>
  )
}

function GrupView({ d }) {
  if (!d) return null
  const u = d.urunler || []
  const tGun = u.reduce((s, x) => s + (x.gun_adet || 0), 0)
  const tTutar = u.reduce((s, x) => s + (x.gun_tutar || 0), 0)
  return (
    <div>
      <div className="flex flex-wrap gap-2 mb-3">
        <div className="px-3 py-1.5 rounded-lg border dark:border-gray-600 bg-slate-50 dark:bg-gray-700/40">
          <div className="text-[10px] text-gray-500">Ürün Çeşidi</div><div className="text-sm font-bold">{u.length}</div>
        </div>
        <div className="px-3 py-1.5 rounded-lg border dark:border-gray-600 bg-blue-50 dark:bg-blue-900/20">
          <div className="text-[10px] text-gray-500">Günlük Toplam Satış</div><div className="text-sm font-bold">{fmt(tGun)} adet</div>
        </div>
        <div className="px-3 py-1.5 rounded-lg border dark:border-gray-600 bg-green-50 dark:bg-green-900/20">
          <div className="text-[10px] text-gray-500">Günlük Toplam Tutar</div><div className="text-sm font-bold text-green-700 dark:text-green-400">{fmt(tTutar)} ₺</div>
        </div>
      </div>
      <table className="w-full">
        <thead><tr><Th>Ürün</Th><Th r>Günlük Satış</Th><Th r>Günlük Tutar</Th><Th r>Dünkü Satış</Th><Th r>7 Gün Önceki</Th></tr></thead>
        <tbody>
          {u.map((x, i) => {
            const rc = x._row_color
            const rcCls = rc === 'green' ? 'bg-green-100 dark:bg-green-900/40' : rc === 'orange' ? 'bg-orange-100 dark:bg-orange-900/40' : ''
            return (
            <tr key={i} className={`border-b border-gray-50 dark:border-gray-700 ${rcCls || 'hover:bg-blue-50/30 dark:hover:bg-blue-900/20'}`}>
              <Td>{x.urun}</Td>
              <Td r cls="font-medium">{fmt(x.gun_adet)}</Td>
              <Td r>{fmt(x.gun_tutar)}</Td>
              <Td r cls="text-gray-500">{fmt(x.dun_adet)}</Td>
              <Td r cls="text-gray-500">{fmt(x.hafta_adet)}</Td>
            </tr>
          )})}
          {u.length === 0 && <tr><td colSpan={5} className="p-4 text-center text-gray-400">Ürün satışı yok</td></tr>}
        </tbody>
      </table>
    </div>
  )
}

function VadeView({ d }) {
  if (!d) return null
  const evraklar = d.evraklar || []
  const K = ({ lbl, val, cls }) => (
    <div className={`px-3 py-1.5 rounded-lg border dark:border-gray-600 ${cls || 'bg-slate-50 dark:bg-gray-700/40'}`}>
      <div className="text-[10px] text-gray-500">{lbl}</div><div className="text-sm font-bold">{val}</div>
    </div>
  )
  return (
    <div>
      <div className="flex flex-wrap gap-2 mb-3">
        <K lbl="Cari" val={d.cari} />
        <K lbl="Açık Evrak" val={d.evrak_sayisi} cls="bg-blue-50 dark:bg-blue-900/20" />
        <K lbl="Toplam Net (TL)" val={`${fmt(d.toplam_net_tl)} ₺`} cls={(d.toplam_net_tl || 0) >= 0 ? 'bg-red-50 dark:bg-red-900/20' : 'bg-green-50 dark:bg-green-900/20'} />
      </div>
      <table className="w-full">
        <thead><tr><Th>Evrak No</Th><Th>Vade</Th><Th>Durum</Th><Th r>Borç</Th><Th r>Alacak</Th><Th r>Net (TL)</Th><Th>Gün Farkı</Th><Th>Modül / Açıklama</Th></tr></thead>
        <tbody>
          {evraklar.map((e, i) => {
            const gf = e.gun_farki
            const gfTxt = gf == null ? 'Vade yok' : gf < 0 ? `${-gf} gün gecikti` : gf === 0 ? 'Bugün' : `${gf} gün kaldı`
            const gfCls = gf == null ? 'text-gray-400' : gf < 0 ? 'text-red-600 font-semibold' : gf <= 6 ? 'text-amber-600' : 'text-green-600'
            return (
              <tr key={i} className="border-b border-gray-50 dark:border-gray-700 hover:bg-blue-50/30 dark:hover:bg-blue-900/20">
                <Td>{e.evrak_no}</Td>
                <Td cls="whitespace-nowrap">{e.vade}</Td>
                <Td cls={e.durum === 'Açık Evrak' ? 'text-red-600' : 'text-amber-600'}>{e.durum}</Td>
                <Td r cls="text-red-600">{e.borc > 0 ? `${fmt(e.borc)} ${e.doviz}` : ''}</Td>
                <Td r cls="text-green-600">{e.alacak > 0 ? `${fmt(e.alacak)} ${e.doviz}` : ''}</Td>
                <Td r cls={e.net_tl >= 0 ? 'text-red-700 font-medium' : 'text-green-700 font-medium'}>{fmt(e.net_tl)} ₺</Td>
                <Td cls={gfCls + ' whitespace-nowrap'}>{gfTxt}</Td>
                <Td cls="text-gray-500 truncate max-w-[220px]" title={e.aciklama}>{e.modul}{e.aciklama ? ` · ${e.aciklama}` : ''}</Td>
              </tr>
            )
          })}
          {evraklar.length === 0 && <tr><td colSpan={8} className="p-4 text-center text-gray-400">Açık evrak yok</td></tr>}
        </tbody>
      </table>
    </div>
  )
}

function SeferListeView({ d, onNavigate, acik, setAcik }) {
  if (!d) return null
  const seferler = d.seferler || []
  // Yıl -> Ay hiyerarşisi
  const yillar = {}
  for (const s of seferler) {
    const ay = s.ay || '-'            // "2026-07"
    const yil = ay.slice(0, 4) || '-'
    if (!yillar[yil]) yillar[yil] = {}
    if (!yillar[yil][ay]) yillar[yil][ay] = { label: s.ay_label || ay, seferler: [] }
    yillar[yil][ay].seferler.push(s)
  }
  const yilKeys = Object.keys(yillar).sort((a, b) => b.localeCompare(a))
  const toggle = (k) => setAcik(p => ({ ...p, [k]: !p[k] }))
  // yıl varsayılan AÇIK, ay varsayılan KAPALI (binlerce sefer için hafif)
  const isAcik = (k, def) => acik[k] === undefined ? def : acik[k]
  // Döviz bazlı topla: bir sefer € + ₺ karışık olabilir; hepsini kendi birimiyle göster
  const gelirOzet = (arr) => {
    const t = {}
    for (const s of arr) for (const [d, v] of Object.entries(s.gelir_dvz || (s.gelir > 0 ? { [s.doviz]: s.gelir } : {}))) t[d] = (t[d] || 0) + v
    return fmtDvz(t)
  }
  const giderOzet = (arr) => {
    const t = {}
    for (const s of arr) for (const [d, v] of Object.entries(s.gider_dvz || (s.gider > 0 ? { [s.doviz]: s.gider } : {}))) t[d] = (t[d] || 0) + v
    return fmtDvz(t)
  }
  const karDvz = (s) => {
    const t = { ...(s.gelir_dvz || {}) }
    for (const [d, v] of Object.entries(s.gider_dvz || {})) t[d] = (t[d] || 0) - v
    return t
  }
  return (
    <div>
      <div className="flex flex-wrap gap-2 mb-3">
        <div className="px-3 py-1.5 rounded-lg border dark:border-gray-600 bg-slate-50 dark:bg-gray-700/40">
          <div className="text-[10px] text-gray-500">Toplam Sefer</div>
          <div className="text-base font-bold tabular-nums">{d.sefer_sayisi || seferler.length}</div>
        </div>
      </div>
      {yilKeys.map(yil => {
        const aylar = yillar[yil]
        const ayKeys = Object.keys(aylar).sort((a, b) => b.localeCompare(a))
        const yilToplam = ayKeys.reduce((sm, ak) => sm + aylar[ak].seferler.length, 0)
        const yilAcik = isAcik('Y' + yil, true)
        return (
          <div key={yil} className="mb-2 border border-slate-300 dark:border-gray-600 rounded-lg overflow-hidden">
            <div onClick={() => toggle('Y' + yil)} className="flex items-center gap-2 px-3 py-2 bg-slate-200 dark:bg-slate-700 cursor-pointer hover:bg-slate-300 dark:hover:bg-slate-600">
              <span className="text-xs w-3">{yilAcik ? '▾' : '▸'}</span>
              <span className="font-bold text-sm">{yil}</span>
              <span className="text-[11px] text-gray-500">({yilToplam} sefer)</span>
            </div>
            {yilAcik && ayKeys.map(ak => {
              const g = aylar[ak]; const ac = isAcik('A' + ak, false)
              return (
                <div key={ak} className="border-t border-slate-200 dark:border-gray-700">
                  <div onClick={() => toggle('A' + ak)} className="flex items-center gap-2 px-3 py-1.5 pl-6 bg-slate-100 dark:bg-gray-700/50 cursor-pointer hover:bg-slate-200 dark:hover:bg-gray-700">
                    <span className="text-xs w-3">{ac ? '▾' : '▸'}</span>
                    <span className="font-semibold text-[13px]">{g.label}</span>
                    <span className="text-[11px] text-gray-500">({g.seferler.length} sefer)</span>
                    <span className="ml-auto flex items-center gap-2 text-[11px] font-medium">
                      <span className="text-green-600 dark:text-green-400">↑ {gelirOzet(g.seferler) || '0'}</span>
                      {giderOzet(g.seferler) && <span className="text-red-600 dark:text-red-400">↓ {giderOzet(g.seferler)}</span>}
                    </span>
                  </div>
                  {ac && (
                    <table className="w-full">
                      <thead><tr><Th>Sefer No</Th><Th>Tarih</Th><Th>Durum</Th><Th>Plaka</Th><Th>Güzergah</Th><Th>Müşteri</Th><Th r>Gelir</Th><Th r>Gider</Th><Th r>Kâr</Th></tr></thead>
                      <tbody>
                        {g.seferler.map((s, i) => (
                          <tr key={i} className="border-b border-gray-50 dark:border-gray-700 hover:bg-blue-50/30 dark:hover:bg-blue-900/20">
                            <Td><span onClick={() => onNavigate && onNavigate({ type: 'sefer', value: s.sefer_no })}
                                  className="text-blue-600 dark:text-blue-400 cursor-pointer hover:underline font-medium">#{s.sefer_no}</span></Td>
                            <Td cls="whitespace-nowrap">{s.tarih}</Td>
                            <Td>{s.durum}</Td>
                            <Td><span onClick={() => (s.plaka && s.plaka !== '-' && onNavigate) ? onNavigate({ type: 'arac', value: s.plaka, extra: { tum: true } }) : null}
                                  className={s.plaka && s.plaka !== '-' ? 'text-blue-600 dark:text-blue-400 cursor-pointer hover:underline' : ''}>{s.plaka}</span></Td>
                            <Td cls="text-gray-500 truncate max-w-[220px]" title={s.guzergah}>{s.guzergah}</Td>
                            <Td cls="truncate max-w-[200px]" title={`${s.gonderici || ''} → ${s.alici || ''}`}>{(() => { const m = (s.gonderici && s.gonderici !== '-') ? s.gonderici : s.alici; return (m && m !== '-' && onNavigate) ? <span onClick={() => onNavigate({ type: 'cari', value: m })} className="text-blue-600 dark:text-blue-400 cursor-pointer hover:underline">{m}</span> : <span className="text-gray-500">{m}</span> })()}</Td>
                            <Td r cls="text-green-600 align-top">{fmtParaList(s.gelir_dvz, s.gelir_tl)}</Td>
                            <Td r cls="text-red-600 align-top">{fmtParaList(s.gider_dvz, s.gider_tl)}</Td>
                            <Td r cls="font-medium align-top text-gray-800 dark:text-gray-200">{fmtDvzList(karDvz(s))}</Td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  )}
                </div>
              )
            })}
          </div>
        )
      })}
      {seferler.length === 0 && <div className="p-4 text-center text-gray-400">Sefer bulunamadı</div>}
    </div>
  )
}

function CariBakiyeListeView({ d, onNavigate }) {
  const [q, setQ] = useState('')
  if (!d) return null
  let cariler = d.cariler || []
  if (q.trim()) cariler = cariler.filter(c => (c.cari || '').toLowerCase().includes(q.toLowerCase()))
  return (
    <div>
      <div className="flex flex-wrap gap-2 mb-3">
        <div className="px-3 py-1.5 rounded-lg border dark:border-gray-600 bg-slate-50 dark:bg-gray-700/40">
          <div className="text-[10px] text-gray-500">Cari Sayısı</div>
          <div className="text-base font-bold tabular-nums">{d.cari_sayisi || cariler.length}</div>
        </div>
      </div>
      <input value={q} onChange={e => setQ(e.target.value)} placeholder="Cari ara..."
        className="w-full mb-2 text-xs border border-slate-300 dark:border-gray-600 rounded px-2 py-1 bg-white dark:bg-gray-900" />
      <table className="w-full">
        <thead><tr><Th>Cari</Th><Th r>Borç</Th><Th r>Alacak</Th><Th r>Bakiye</Th></tr></thead>
        <tbody>
          {cariler.map((c, i) => (
            <tr key={i} className="border-b border-gray-50 dark:border-gray-700 hover:bg-blue-50/30 dark:hover:bg-blue-900/20">
              <Td><span onClick={() => onNavigate && onNavigate({ type: 'cari', value: c.cari })}
                    className="text-blue-600 dark:text-blue-400 cursor-pointer hover:underline">{c.cari}</span></Td>
              <Td r cls="text-gray-600 whitespace-nowrap">{fmtPara(c.borc_dvz, c.borc_tl)}</Td>
              <Td r cls="text-gray-600 whitespace-nowrap">{fmtPara(c.alacak_dvz, c.alacak_tl)}</Td>
              <Td r cls={`whitespace-nowrap ${(c.net_tl || 0) >= 0 ? 'text-red-700 font-medium' : 'text-green-700 font-medium'}`}>{fmtPara(c.bakiye_dvz, c.net_tl)}</Td>
            </tr>
          ))}
          {cariler.length === 0 && <tr><td colSpan={4} className="p-4 text-center text-gray-400">Cari bulunamadı</td></tr>}
        </tbody>
      </table>
    </div>
  )
}

// Gider Raporu pastasından: TÜM gider kalemleri hiyerarşik — kalem -> yıl -> ay -> detay (plaka/tarih/tutar)
function GiderDetayView({ d }) {
  const [acik, setAcik] = useState({})
  const [q, setQ] = useState('')
  if (!d) return null
  let kalemler = d.kalemler || []
  if (q.trim()) {
    const s = q.toLowerCase()
    kalemler = kalemler.filter(k => (k.tur || '').toLowerCase().includes(s) || (k.plaka || '').toLowerCase().includes(s))
  }
  const tog = (key) => setAcik(p => ({ ...p, [key]: !p[key] }))
  const topla = (items) => { const t = {}; for (const it of items) t[it.doviz] = (t[it.doviz] || 0) + it.tutar; return t }
  // grupla: tur -> yil -> ay -> { label, items }
  const G = {}
  for (const k of kalemler) {
    G[k.tur] ??= {}
    G[k.tur][k.yil] ??= {}
    G[k.tur][k.yil][k.ay] ??= { label: k.ay_label, items: [] }
    G[k.tur][k.yil][k.ay].items.push(k)
  }
  const turItems = (tur) => Object.values(G[tur]).flatMap(y => Object.values(y).flatMap(a => a.items))
  const turlar = Object.keys(G).sort((a, b) => (topla(turItems(b))['€'] || 0) - (topla(turItems(a))['€'] || 0))
  return (
    <div>
      <div className="flex flex-wrap gap-2 mb-3">
        <div className="px-3 py-1.5 rounded-lg border dark:border-gray-600 bg-slate-50 dark:bg-gray-700/40">
          <div className="text-[10px] text-gray-500">Gider Kalemi</div>
          <div className="text-base font-bold tabular-nums">{turlar.length}</div>
        </div>
        <div className="px-3 py-1.5 rounded-lg border dark:border-gray-600 bg-slate-50 dark:bg-gray-700/40">
          <div className="text-[10px] text-gray-500">Toplam İşlem</div>
          <div className="text-base font-bold tabular-nums">{d.kalem_sayisi || kalemler.length}</div>
        </div>
      </div>
      <input value={q} onChange={e => setQ(e.target.value)} placeholder="Gider kalemi / plaka ara..."
        className="w-full mb-2 text-xs border border-slate-300 dark:border-gray-600 rounded px-2 py-1 bg-white dark:bg-gray-900" />
      <div className="space-y-1">
        {turlar.map(tur => {
          const items = turItems(tur)
          return (
            <div key={tur} className="border border-gray-200 dark:border-gray-700 rounded overflow-hidden">
              <div onClick={() => tog(tur)}
                className="flex justify-between items-center px-2 py-1.5 cursor-pointer bg-slate-100 dark:bg-gray-700/50 hover:bg-slate-200 dark:hover:bg-gray-700 font-semibold text-sm">
                <span>{acik[tur] ? '▼' : '▶'} {tur} <span className="text-gray-400 text-xs font-normal">({items.length} işlem)</span></span>
                <span className="text-red-600 dark:text-red-400 whitespace-nowrap">{fmtDvz(topla(items))}</span>
              </div>
              {acik[tur] && Object.keys(G[tur]).sort((a, b) => Number(b) - Number(a)).map(yil => {
                const ykey = `${tur}|${yil}`
                const yitems = Object.values(G[tur][yil]).flatMap(a => a.items)
                return (
                  <div key={yil} className="ml-2 border-l-2 border-gray-100 dark:border-gray-700">
                    <div onClick={() => tog(ykey)}
                      className="flex justify-between items-center px-2 py-1 cursor-pointer hover:bg-slate-50 dark:hover:bg-gray-800 text-sm font-medium">
                      <span>{acik[ykey] ? '▼' : '▶'} {yil}</span>
                      <span className="text-red-500 text-xs whitespace-nowrap">{fmtDvz(topla(yitems))}</span>
                    </div>
                    {acik[ykey] && Object.keys(G[tur][yil]).sort().reverse().map(ay => {
                      const akey = `${ykey}|${ay}`
                      const adata = G[tur][yil][ay]
                      return (
                        <div key={ay} className="ml-2 border-l-2 border-gray-100 dark:border-gray-700">
                          <div onClick={() => tog(akey)}
                            className="flex justify-between items-center px-2 py-1 cursor-pointer hover:bg-slate-50 dark:hover:bg-gray-800 text-xs">
                            <span>{acik[akey] ? '▼' : '▶'} {adata.label} <span className="text-gray-400">({adata.items.length})</span></span>
                            <span className="text-red-500 whitespace-nowrap">{fmtDvz(topla(adata.items))}</span>
                          </div>
                          {acik[akey] && (
                            <table className="w-full ml-2 text-xs mb-1">
                              <thead><tr className="text-gray-400"><Th>Tarih</Th><Th>Plaka</Th><Th>Açıklama</Th><Th r>Tutar</Th></tr></thead>
                              <tbody>
                                {adata.items.map((it, i) => (
                                  <tr key={i} className="border-b border-gray-50 dark:border-gray-800">
                                    <Td cls="whitespace-nowrap">{it.tarih}</Td>
                                    <Td cls="font-medium">{it.plaka}</Td>
                                    <Td cls="text-gray-500 truncate max-w-[180px]">{it.aciklama}</Td>
                                    <Td r cls="text-red-600 whitespace-nowrap">{fmt(it.tutar)} {it.doviz}</Td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          )}
                        </div>
                      )
                    })}
                  </div>
                )
              })}
            </div>
          )
        })}
        {turlar.length === 0 && <div className="p-4 text-center text-gray-400">Gider bulunamadı</div>}
      </div>
    </div>
  )
}

function AracListeView({ d, onNavigate }) {
  const [q, setQ] = useState('')
  if (!d) return null
  let araclar = d.araclar || []
  if (q.trim()) araclar = araclar.filter(a => (a.plaka || '').toLowerCase().includes(q.toLowerCase()))
  return (
    <div>
      <div className="flex flex-wrap gap-2 mb-3">
        <div className="px-3 py-1.5 rounded-lg border dark:border-gray-600 bg-slate-50 dark:bg-gray-700/40">
          <div className="text-[10px] text-gray-500">Araç Sayısı</div>
          <div className="text-base font-bold tabular-nums">{d.arac_sayisi || araclar.length}</div>
        </div>
      </div>
      <input value={q} onChange={e => setQ(e.target.value)} placeholder="Plaka ara..."
        className="w-full mb-2 text-xs border border-slate-300 dark:border-gray-600 rounded px-2 py-1 bg-white dark:bg-gray-900" />
      <table className="w-full">
        <thead><tr><Th>Plaka</Th><Th>Grup</Th></tr></thead>
        <tbody>
          {araclar.map((a, i) => (
            <tr key={i} className="border-b border-gray-50 dark:border-gray-700 hover:bg-blue-50/30 dark:hover:bg-blue-900/20">
              <Td><span onClick={() => onNavigate && onNavigate({ type: 'arac', value: a.plaka, extra: { tum: true } })}
                    className="text-blue-600 dark:text-blue-400 cursor-pointer hover:underline font-medium">{a.plaka}</span></Td>
              <Td cls="text-gray-500">{a.grup}</Td>
            </tr>
          ))}
          {araclar.length === 0 && <tr><td colSpan={2} className="p-4 text-center text-gray-400">Araç bulunamadı</td></tr>}
        </tbody>
      </table>
    </div>
  )
}

function SoforView({ d, onNavigate }) {
  if (!d) return null
  const seferler = d.seferler || []
  const Kart = ({ lbl, val, cls }) => (
    <div className={`px-3 py-1.5 rounded-lg border dark:border-gray-600 ${cls || 'bg-slate-50 dark:bg-gray-700/40'}`}>
      <div className="text-[10px] text-gray-500">{lbl}</div><div className="text-sm font-bold">{val}</div>
    </div>
  )
  return (
    <div>
      <div className="flex flex-wrap gap-2 mb-3">
        <Kart lbl="Şoför" val={d.sofor} />
        {d.telefon ? <Kart lbl="Telefon" val={d.telefon} /> : null}
        <Kart lbl="Toplam Sefer" val={d.toplam_sefer} cls="bg-blue-50 dark:bg-blue-900/20" />
        <Kart lbl="Yurt İçi" val={d.yurtici} cls="bg-green-50 dark:bg-green-900/20" />
        <Kart lbl="Yurt Dışı" val={d.yurtdisi} cls="bg-amber-50 dark:bg-amber-900/20" />
      </div>
      <SeferOzet ozet={d.ozet} />
      <table className="w-full">
        <thead><tr><Th>Tarih</Th><Th>Plaka</Th><Th>Güzergah</Th><Th>Tip</Th><Th>Durum</Th><Th r>Gelir</Th><Th r>Gider</Th><Th r>Kar</Th><Th r>Sefer No</Th></tr></thead>
        <tbody>
          {seferler.map((s, i) => (
            <tr key={i} className="border-b border-gray-50 dark:border-gray-700 hover:bg-blue-50/30 dark:hover:bg-blue-900/20">
              <Td cls="whitespace-nowrap">{s.tarih}</Td>
              <Td>{s.plaka}</Td>
              <Td cls="text-gray-500 truncate max-w-[240px]" title={s.guzergah}>{s.guzergah}</Td>
              <Td cls={s.tip === 'Yurt Dışı' ? 'text-amber-600' : 'text-green-600'}>{s.tip}</Td>
              <Td cls="text-gray-500">{s.durum}</Td>
              <Td r cls="tabular-nums text-green-600" title={dvzAcikla(s.dovizler, 'gelir')}>{tlYaz(s.gelir_tl)}</Td>
              <Td r cls="tabular-nums text-red-600" title={dvzAcikla(s.dovizler, 'gider')}>{tlYaz(s.gider_tl)}</Td>
              <Td r cls={`tabular-nums font-medium ${(s.kar_tl || 0) >= 0 ? 'text-emerald-700 dark:text-emerald-400' : 'text-red-700 dark:text-red-400'}`}>{tlYaz(s.kar_tl)}</Td>
              <Td r><span onClick={() => onNavigate && onNavigate({ type: 'sefer', value: s.sefer_no })}
                className="text-blue-600 dark:text-blue-400 cursor-pointer hover:underline font-medium">#{s.sefer_no}</span></Td>
            </tr>
          ))}
          {seferler.length === 0 && <tr><td colSpan={9} className="p-4 text-center text-gray-400">Sefer kaydı yok</td></tr>}
        </tbody>
      </table>
    </div>
  )
}

function AracView({ d, onNavigate }) {
  const [acik, setAcik] = useState({})
  if (!d) return null
  const kalemler = [...(d.kalemler || [])].sort((a, b) => String(b.tarih || '').localeCompare(String(a.tarih || '')))
  // yil -> ay -> islemler (hiyerarsik, cari modaliyla ayni)
  const grup = {}
  kalemler.forEach(h => {
    const t = String(h.tarih || ''); const y = t.slice(0, 4) || '?'; const a = t.slice(0, 7) || '?'
    if (!grup[y]) grup[y] = {}
    if (!grup[y][a]) grup[y][a] = []
    grup[y][a].push(h)
  })
  const yillar = Object.keys(grup).sort().reverse()
  const enYeniYil = yillar[0]
  const enYeniAy = Object.keys(grup[enYeniYil] || {}).sort().reverse()[0]
  const acikMi = (k, defAcik) => (acik[k] === undefined ? defAcik : acik[k])
  const tgl = (k, defAcik) => setAcik(p => ({ ...p, [k]: !acikMi(k, defAcik) }))
  const topla = (rows, alan) => {
    const o = {}
    rows.forEach(h => { const v = Number(h[alan]) || 0; if (v > 0.004) o[h.doviz] = (o[h.doviz] || 0) + v })
    return Object.entries(o).map(([dv, v]) => `${fmt(v)} ${dv}`).join(' · ')
  }
  const SeferHucre = ({ h }) => h.sefer_no
    ? <span onClick={() => onNavigate && onNavigate({ type: 'sefer', value: h.sefer_no })}
        className="text-blue-600 dark:text-blue-400 cursor-pointer hover:underline font-medium">#{h.sefer_no}</span>
    : <span className="text-gray-400">—</span>
  return (
    <div>
      <div className="flex flex-wrap gap-2 mb-3">
        <div className="px-3 py-1.5 rounded-lg border dark:border-gray-600 bg-slate-50 dark:bg-gray-700/40">
          <div className="text-[10px] text-gray-500">Dönem</div><div className="text-sm font-bold">{d.donem}</div>
        </div>
        <div className="px-3 py-1.5 rounded-lg border dark:border-gray-600 bg-green-50 dark:bg-green-900/20">
          <div className="text-[10px] text-gray-500">Toplam Gelir</div><div className="text-sm font-bold text-green-700 dark:text-green-400">{fmtDvz(d.gelir_dvz)}</div>
        </div>
        <div className="px-3 py-1.5 rounded-lg border dark:border-gray-600 bg-red-50 dark:bg-red-900/20">
          <div className="text-[10px] text-gray-500">Toplam Gider</div><div className="text-sm font-bold text-red-700 dark:text-red-400">{fmtDvz(d.gider_dvz)}</div>
        </div>
      </div>
      <table className="w-full">
        <thead><tr><Th>Tarih</Th><Th>Tip</Th><Th>Stok/Kalem</Th><Th>Açıklama</Th><Th r>Miktar</Th><Th r>Br.Fiyat</Th><Th r>Gider</Th><Th r>Gelir</Th><Th r>Sefer</Th></tr></thead>
        <tbody>
          {yillar.flatMap(y => {
            const yk = `y${y}`; const yAcik = acikMi(yk, y === enYeniYil)
            const yRows = Object.values(grup[y]).flat()
            const out = [(
              <tr key={yk} onClick={() => tgl(yk, y === enYeniYil)}
                className="bg-slate-200 dark:bg-slate-700 cursor-pointer hover:bg-slate-300 dark:hover:bg-slate-600 select-none">
                <Td cls="font-bold whitespace-nowrap">{yAcik ? '▾' : '▸'} {y} ({yRows.length})</Td>
                <Td /><Td /><Td /><Td /><Td />
                <Td r cls="text-red-600 font-bold">{topla(yRows, 'borc')}</Td>
                <Td r cls="text-green-600 font-bold">{topla(yRows, 'alacak')}</Td>
                <Td />
              </tr>
            )]
            if (!yAcik) return out
            Object.keys(grup[y]).sort().reverse().forEach(a => {
              const ak = `a${a}`; const aAcik = acikMi(ak, a === enYeniAy)
              const rows = grup[y][a]
              const ayNo = parseInt(a.split('-')[1]) || 0
              out.push(
                <tr key={ak} onClick={() => tgl(ak, a === enYeniAy)}
                  className="bg-gray-50 dark:bg-gray-700/50 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700 select-none">
                  <Td cls="pl-4 font-semibold text-gray-600 dark:text-gray-300 whitespace-nowrap">{aAcik ? '▾' : '▸'} {AY_ADI[ayNo] || a} ({rows.length})</Td>
                  <Td /><Td /><Td /><Td /><Td />
                  <Td r cls="text-red-500 font-medium">{topla(rows, 'borc')}</Td>
                  <Td r cls="text-green-500 font-medium">{topla(rows, 'alacak')}</Td>
                  <Td />
                </tr>
              )
              if (aAcik) rows.forEach((h, i) => out.push(
                <tr key={`${ak}-${i}`} className="border-b border-gray-50 dark:border-gray-700 hover:bg-blue-50/30 dark:hover:bg-blue-900/20">
                  <Td cls="pl-7 whitespace-nowrap">{h.tarih}</Td>
                  <Td cls={h.alacak > 0 ? 'text-green-600 font-medium' : 'text-gray-600'}>{h.tip}</Td>
                  <Td>{h.stok}</Td>
                  <Td cls="text-gray-500 truncate max-w-[220px]" title={h.aciklama}>{h.aciklama}</Td>
                  <Td r>{h.miktar ? `${fmt(h.miktar)} ${h.birim}` : ''}</Td>
                  <Td r>{h.birim_fiyat ? `${fmt(h.birim_fiyat)} ${h.doviz}` : ''}</Td>
                  <Td r cls="text-red-600">{h.borc > 0 ? `${fmt(h.borc)} ${h.doviz}` : ''}</Td>
                  <Td r cls="text-green-600">{h.alacak > 0 ? `${fmt(h.alacak)} ${h.doviz}` : ''}</Td>
                  <Td r><SeferHucre h={h} /></Td>
                </tr>
              ))
            })
            return out
          })}
          {kalemler.length === 0 && <tr><td colSpan={9} className="p-4 text-center text-gray-400">Bu dönem kaydı yok</td></tr>}
        </tbody>
      </table>
    </div>
  )
}
